const elements = [
  {
    type: "line",
    version: 1410,
    versionNonce: 1928354898,
    isDeleted: true,
    id: "UCPRHesC611iwo9xAWlyk",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 37.52777127933288,
    y: 615.6448729765475,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 967.2113794132033,
    height: 0,
    seed: 293467213,
    groupIds: ["1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [967.2113794132033, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "text",
    version: 2489,
    versionNonce: 940558798,
    isDeleted: true,
    id: "GLU1sD9Kux_ek1tUsYe4j",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 360.4898114888666,
    y: 1280.474007617211,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 321.22164917959776,
    height: 27.054255150357545,
    seed: 388124259,
    groupIds: ["HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 21.463797232069055,
    fontFamily: 1,
    text: "CLOUD/LAMBDA FUNCTIONS",
    baseline: 19.054255150357545,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2156,
    versionNonce: 1761935890,
    isDeleted: true,
    id: "6KIZXOkIpsMkpAaqYcTxX",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 363.6510728188031,
    y: 1364.9041241653078,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 73.54184850730996,
    height: 13.33660465158471,
    seed: 606298135,
    groupIds: ["Dv3UWpzOBghjtW2mjt6dp", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.66928372126778,
    fontFamily: 1,
    text: "Authentication",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1958,
    versionNonce: 1464950798,
    isDeleted: true,
    id: "S19jekWaWCBiF0P2G5PmM",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 363.6510728188001,
    y: 1383.7868674511985,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 81.924857145449,
    height: 47.63073089851689,
    seed: 51201335,
    groupIds: ["Dv3UWpzOBghjtW2mjt6dp", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762697,
    fontFamily: 1,
    text: "- createUserFirestore\n\n- deleteUserFirestore\n\n- disableNewUser",
    baseline: 44.63073089851689,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2334,
    versionNonce: 150925266,
    isDeleted: true,
    id: "_FTs4JVek35r1Z8OJ_xTY",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 363.7973414323551,
    y: 1452.7287915294148,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 47.63073089851689,
    height: 13.33660465158471,
    seed: 502624055,
    groupIds: ["J5KkrgusEfaWScQWu--kJ", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267782,
    fontFamily: 1,
    text: "Firestore",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2286,
    versionNonce: 1048981070,
    isDeleted: true,
    id: "nLJtfW7jtGiRwBeMZlkFa",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 363.7217370975983,
    y: 1471.632601900273,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 145.9405594730555,
    height: 85.73531561733037,
    seed: 783350103,
    groupIds: ["J5KkrgusEfaWScQWu--kJ", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762694,
    fontFamily: 1,
    text:
      "- deletePostImagesAndComments\n\n- generate/deleteCommentNotifications\n\n- generate/deletePostNotifications\n\n- generateCommentLikeNotification\n\n- generatePostLikeNotification",
    baseline: 82.73531561733037,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2525,
    versionNonce: 1995777426,
    isDeleted: true,
    id: "4r1mzMWC50XuC3L1wnZ0N",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 589.6986054271586,
    y: 1365.4173863516983,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 76.20916943762691,
    height: 13.33660465158471,
    seed: 1019264377,
    groupIds: ["XLDf7NTFTUo0e0MzNbsF4", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267776,
    fontFamily: 1,
    text: "Cloud Storage",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2348,
    versionNonce: 2055681166,
    isDeleted: true,
    id: "oOkc51bCEaBiBG7Q532sY",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 589.6966723617763,
    y: 1384.302062702988,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 87.64054485327088,
    height: 28.5784385391101,
    seed: 1687987801,
    groupIds: ["XLDf7NTFTUo0e0MzNbsF4", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762694,
    fontFamily: 1,
    text: "- updateSuppliersConfig\n\n- updateKeywordsIds",
    baseline: 25.5784385391101,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2615,
    versionNonce: 1008640850,
    isDeleted: true,
    id: "qfAQL1BHZpfKIj1Aa6rio",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 589.6928062310196,
    y: 1432.0366184521665,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 33.15098870536771,
    height: 13.33660465158471,
    seed: 1254245015,
    groupIds: ["feMUrNmLFVn9u08U8C-Uk", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267764,
    fontFamily: 1,
    text: "HTTP",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2496,
    versionNonce: 353202894,
    isDeleted: true,
    id: "9hoEzViczpuHv-AQRU71f",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 589.7855933691394,
    y: 1450.9193617380745,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 74.68498604887442,
    height: 66.68302325792362,
    seed: 1756092343,
    groupIds: ["feMUrNmLFVn9u08U8C-Uk", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762696,
    fontFamily: 1,
    text: "- updateUserEntries\n\n- getAllUsers\n\n- getAllPosts\n\n- addUserDoc",
    baseline: 63.68302325792362,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2849,
    versionNonce: 584214802,
    isDeleted: true,
    id: "KRrIRna2J86mmpUaO8KI9",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 589.6251489428157,
    y: 1539.5182752098492,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 49.1549142872693,
    height: 13.33660465158471,
    seed: 1951291033,
    groupIds: ["1i6k-sV76OhwkOWLq0KjU", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267758,
    fontFamily: 1,
    text: "Scheduled",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2748,
    versionNonce: 2024925454,
    isDeleted: true,
    id: "W8yDV7UcpSA2w5-BPxuvE",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 589.7179360809325,
    y: 1558.4319475417856,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 88.78368239483534,
    height: 9.526146179703364,
    seed: 1163533177,
    groupIds: ["1i6k-sV76OhwkOWLq0KjU", "TTcvpU8Yzqwy30gBF14jC", "HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762695,
    fontFamily: 1,
    text: "- deleteOldNotifications",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1517,
    versionNonce: 310867666,
    isDeleted: true,
    id: "tbSPvr_-80DNPp5A1JbAF",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 341.47034403672546,
    y: 1325.4888049851197,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 359.3262338984106,
    height: 15.241833887525393,
    seed: 1281262797,
    groupIds: ["HuxFp7olLcSIK2reOPuNw", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.0967335550101325,
    fontFamily: 1,
    text:
      "These functions are basically backend code executed when some event is triggered. Here we have the list of functions\npowering the application classified by event-type trigger:",
    baseline: 13.241833887525393,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2234,
    versionNonce: 1424856910,
    isDeleted: true,
    id: "7gIGnrk4q5yG9mRCxyfwB",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 385.8833073483896,
    y: 664.3900074079818,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 270.5425515035761,
    height: 27.054255150357545,
    seed: 224723799,
    groupIds: ["C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 21.46379723206907,
    fontFamily: 1,
    text: "DATABASE STRUCTURE",
    baseline: 19.054255150357545,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1305,
    versionNonce: 1809108114,
    isDeleted: true,
    id: "RK1X79jade27H7YmbEOE1",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 294.022437129006,
    y: 709.4272891886562,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 454.2066498482566,
    height: 28.5784385391101,
    seed: 1139797197,
    groupIds: ["7mnvJ2ecXlicdmeHg9Y8E", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.6209169437627065,
    fontFamily: 1,
    text:
      "GCP offers a non-relational database solution with Firebase, which is based in collections/sub-collections of documents.\nThe main two collections for this app were Users and Posts:\n",
    baseline: 25.5784385391101,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1464,
    versionNonce: 35224974,
    isDeleted: true,
    id: "7k_ICNlrBCgtaYk_RBLVx",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 493.67182885027887,
    y: 709.4407155503286,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 32.00785116380334,
    height: 9.526146179703364,
    seed: 440781101,
    groupIds: ["7mnvJ2ecXlicdmeHg9Y8E", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762693,
    fontFamily: 1,
    text: "Firebase",
    baseline: 6.526146179703364,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1466,
    versionNonce: 1685154386,
    isDeleted: true,
    id: "U5wsoc4osBIpTndqihzvx",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 460.8848657716876,
    y: 718.8562626551552,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 21.338567442535535,
    height: 9.526146179703364,
    seed: 1079474541,
    groupIds: ["7mnvJ2ecXlicdmeHg9Y8E", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762679,
    fontFamily: 1,
    text: "Users",
    baseline: 6.526146179703364,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1279,
    versionNonce: 1701747662,
    isDeleted: true,
    id: "agBYl8duSb1dh4VkEZVaT",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 502.7340284133926,
    y: 718.8768422372586,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 21.338567442535535,
    height: 9.526146179703364,
    seed: 339503949,
    groupIds: ["7mnvJ2ecXlicdmeHg9Y8E", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762679,
    fontFamily: 1,
    text: "Posts",
    baseline: 6.526146179703364,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 3920,
    versionNonce: 1664372754,
    isDeleted: true,
    id: "Qb44P34ixcwbe7mruoalq",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 76.44905079640444,
    y: 869.0167287368795,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 142.05543153469625,
    height: 167.74040512357644,
    seed: 1980619222,
    groupIds: [
      "xjIPgb0RXurBAk-ZwZV3e",
      "j_9fpJHXdmgzbD0DX4JQy",
      "TT8r_By1TR37FtIJWvd3k",
      "ejMbHDy2o_Y81UiraGhqM",
      "fpN62_MS6SZ9whiwHY8P4",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 3945,
    versionNonce: 1426453006,
    isDeleted: true,
    id: "xPjtKG7kwfWcE9SwsaELn",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 64.25181159376677,
    y: 856.9657687382769,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 148.86082831226042,
    height: 173.71719698356995,
    seed: 572534550,
    groupIds: [
      "xjIPgb0RXurBAk-ZwZV3e",
      "j_9fpJHXdmgzbD0DX4JQy",
      "TT8r_By1TR37FtIJWvd3k",
      "ejMbHDy2o_Y81UiraGhqM",
      "fpN62_MS6SZ9whiwHY8P4",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ"]
  },
  {
    type: "rectangle",
    version: 3745,
    versionNonce: 1544846802,
    isDeleted: true,
    id: "QBglMK4XRFsug3XfidaSQ",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 52.20431313083934,
    y: 844.7131449648211,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 155.36228305759357,
    height: 178.6611405993984,
    seed: 1538645078,
    groupIds: [
      "xjIPgb0RXurBAk-ZwZV3e",
      "j_9fpJHXdmgzbD0DX4JQy",
      "TT8r_By1TR37FtIJWvd3k",
      "ejMbHDy2o_Y81UiraGhqM",
      "fpN62_MS6SZ9whiwHY8P4",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "text",
    version: 2409,
    versionNonce: 2077786190,
    isDeleted: true,
    id: "OOk-F3P-QVt9kKnMjJ-Sd",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 121.03406897466962,
    y: 854.8718749251343,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 22.86275083128808,
    height: 13.33660465158471,
    seed: 203374294,
    groupIds: ["TT8r_By1TR37FtIJWvd3k", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267766,
    fontFamily: 1,
    text: "User",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2707,
    versionNonce: 740881298,
    isDeleted: true,
    id: "RVMIOPEsPGwTHmfWtLZiG",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 63.75922276062062,
    y: 875.3540122876686,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 137.9385966821049,
    height: 133.36604651584724,
    seed: 448590870,
    groupIds: ["TT8r_By1TR37FtIJWvd3k", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267774,
    fontFamily: 1,
    text:
      "+ name: String\n+ email: String\n+ photoUrl: URL\n+ supplierInfo\n  - supplierName: String\n  - primaryColor: String\n  - secondaryColor: String\n  - supplierLogo: URL\n    ...\n+ cookieConsent: Boolean",
    baseline: 129.36604651584724,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 4140,
    versionNonce: 1035945614,
    isDeleted: true,
    id: "XgqEqRBTGLoHMwB0gjdMP",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 322.01823235131087,
    y: 964.882011824174,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 147.8809109717937,
    height: 85.26676165562958,
    seed: 1497045079,
    groupIds: ["NV6GaK2nweGQdo0EPLsMK", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4240,
    versionNonce: 1973989714,
    isDeleted: true,
    id: "3gQAWRW9hH7h2zs7RnYcF",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 314.42586807610576,
    y: 957.3543880707664,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 152.0426110126278,
    height: 88.59936491974173,
    seed: 1694758263,
    groupIds: ["NV6GaK2nweGQdo0EPLsMK", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ"]
  },
  {
    type: "rectangle",
    version: 4319,
    versionNonce: 460539086,
    isDeleted: true,
    id: "78_AwQgQS8jQllcugIjDL",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 306.62437121534276,
    y: 949.6469303287067,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 156.66810559802815,
    height: 92.69878969580866,
    seed: 2046045847,
    groupIds: ["NV6GaK2nweGQdo0EPLsMK", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "text",
    version: 2771,
    versionNonce: 2078979858,
    isDeleted: true,
    id: "up_-Nt47sJ87WtaO-doZr",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 358.19400989523615,
    y: 959.8457091404514,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 60.205243855725264,
    height: 13.33660465158471,
    seed: 1603056855,
    groupIds: ["NV6GaK2nweGQdo0EPLsMK", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267755,
    fontFamily: 1,
    text: "Notification",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3128,
    versionNonce: 378370830,
    isDeleted: true,
    id: "rek3ITy10zaz7gGwL8a8_",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 311.8865952928036,
    y: 980.9761269177397,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 82.68694883982515,
    height: 53.34641860633884,
    seed: 1475215863,
    groupIds: ["NV6GaK2nweGQdo0EPLsMK", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["2eTzultbqtI2zYmfhheWI"],
    fontSize: 10.669283721267758,
    fontFamily: 1,
    text: "+ author: User\n+ seen: Boolean\n+ count: Number\n+ parentId: uid",
    baseline: 49.34641860633884,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 2167,
    versionNonce: 2137392338,
    isDeleted: true,
    id: "51jHdXRz7muKmnCVJjH80",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 262.0782037429096,
    y: 870.8008056349954,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 0,
    height: 130.2157781052724,
    seed: 1188750039,
    groupIds: ["eUKXN7jx2bH7uLhs4y7dF", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [0, 130.2157781052724]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 4134,
    versionNonce: 361163086,
    isDeleted: true,
    id: "kolDJ4SN-0geQFnJ2VFaQ",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 262.24407241521806,
    y: 870.997090401341,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 44.16788710207145,
    height: 0.023762964699988176,
    seed: 2099760985,
    groupIds: ["eUKXN7jx2bH7uLhs4y7dF", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "_02VDIbYd43uB72sxGpjQ",
      focus: 1.2206165204613506,
      gap: 6.234080338997444
    },
    points: [
      [0, 0],
      [44.16788710207145, -0.023762964699988176]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "arrow",
    version: 4545,
    versionNonce: 431069842,
    isDeleted: true,
    id: "2eTzultbqtI2zYmfhheWI",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 262.35742570766917,
    y: 1000.8074536130264,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 43.633437315602265,
    height: 0,
    seed: 581166745,
    groupIds: ["eUKXN7jx2bH7uLhs4y7dF", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "rek3ITy10zaz7gGwL8a8_",
      focus: 0.25650766393040675,
      gap: 5.895732269532118
    },
    points: [
      [0, 0],
      [43.633437315602265, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 2307,
    versionNonce: 1203277710,
    isDeleted: true,
    id: "1ELS2DiFI8mMwGPz1zRa-",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 208.16966870090494,
    y: 941.24276255257,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 53.735650985400156,
    height: 0,
    seed: 1233496345,
    groupIds: ["eUKXN7jx2bH7uLhs4y7dF", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [53.735650985400156, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "rectangle",
    version: 3962,
    versionNonce: 428111954,
    isDeleted: true,
    id: "jtohlVJXWtlbvcxlxlR2E",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 322.74091482063113,
    y: 856.5166219098567,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 147.8809109717937,
    height: 43.694193774601715,
    seed: 192754168,
    groupIds: ["A_xj1aSIx2HQRUdJYn2ag", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 3982,
    versionNonce: 156986830,
    isDeleted: true,
    id: "Lny4T-MJDfoFJ5aBUUzou",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 315.0154340137593,
    y: 848.6832166299528,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 152.0426110126278,
    height: 47.8123158045374,
    seed: 1911829240,
    groupIds: ["A_xj1aSIx2HQRUdJYn2ag", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ", "kolDJ4SN-0geQFnJ2VFaQ"]
  },
  {
    type: "rectangle",
    version: 4043,
    versionNonce: 1588960786,
    isDeleted: true,
    id: "6RY4ToJxpWVHuFp-lteNl",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 307.28233801768283,
    y: 841.0375084201492,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 156.66810559802815,
    height: 51.58492646234712,
    seed: 1407390712,
    groupIds: ["A_xj1aSIx2HQRUdJYn2ag", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["kolDJ4SN-0geQFnJ2VFaQ"]
  },
  {
    type: "text",
    version: 2783,
    versionNonce: 1200129038,
    isDeleted: true,
    id: "tAMN0lfi70yr-CySYcPxT",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 349.3947731443785,
    y: 851.533709651399,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 72.77975681293387,
    height: 13.33660465158471,
    seed: 927847672,
    groupIds: ["A_xj1aSIx2HQRUdJYn2ag", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267798,
    fontFamily: 1,
    text: "Watchlist item",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2978,
    versionNonce: 909904850,
    isDeleted: true,
    id: "1s6rYffy6mdHlo0DBfnH-",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 312.6811840587691,
    y: 872.4473299442873,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 104.78760797673712,
    height: 13.33660465158471,
    seed: 1102607864,
    groupIds: ["A_xj1aSIx2HQRUdJYn2ag", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["kolDJ4SN-0geQFnJ2VFaQ"],
    fontSize: 10.66928372126779,
    fontFamily: 1,
    text: "+ dateAdded: Date",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 3963,
    versionNonce: 1681445454,
    isDeleted: true,
    id: "XfhTNHC8hUeDX6Wypctat",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 322.70577061814936,
    y: 856.5166219098567,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 147.8809109717937,
    height: 43.694193774601715,
    seed: 602782497,
    groupIds: [
      "tZc6sLyTeQv_hOKapJ1vn",
      "A_xj1aSIx2HQRUdJYn2ag",
      "ejMbHDy2o_Y81UiraGhqM",
      "fpN62_MS6SZ9whiwHY8P4",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 3989,
    versionNonce: 909033874,
    isDeleted: true,
    id: "5EP13sCqMBaleng4N3cIY",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 315.1808184960472,
    y: 848.6832166299528,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 152.0426110126278,
    height: 47.8123158045374,
    seed: 657965935,
    groupIds: [
      "tZc6sLyTeQv_hOKapJ1vn",
      "A_xj1aSIx2HQRUdJYn2ag",
      "ejMbHDy2o_Y81UiraGhqM",
      "fpN62_MS6SZ9whiwHY8P4",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ", "kolDJ4SN-0geQFnJ2VFaQ"]
  },
  {
    type: "rectangle",
    version: 4095,
    versionNonce: 440752270,
    isDeleted: true,
    id: "OjrDrp7Jhei8xhgCTKanH",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 307.41257829747906,
    y: 841.0375084201492,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 156.66810559802815,
    height: 51.58492646234712,
    seed: 1537978113,
    groupIds: [
      "tZc6sLyTeQv_hOKapJ1vn",
      "A_xj1aSIx2HQRUdJYn2ag",
      "ejMbHDy2o_Y81UiraGhqM",
      "fpN62_MS6SZ9whiwHY8P4",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["kolDJ4SN-0geQFnJ2VFaQ"]
  },
  {
    type: "text",
    version: 2782,
    versionNonce: 432324434,
    isDeleted: true,
    id: "b_fB1ASEykEVnyxA8ObQl",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 349.3596289418914,
    y: 851.533709651399,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 72.77975681293387,
    height: 13.33660465158471,
    seed: 2122174666,
    groupIds: ["A_xj1aSIx2HQRUdJYn2ag", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267798,
    fontFamily: 1,
    text: "Watchlist item",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3019,
    versionNonce: 1634145998,
    isDeleted: true,
    id: "_02VDIbYd43uB72sxGpjQ",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 312.64603985628696,
    y: 872.4473299442873,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 104.78760797673712,
    height: 13.33660465158471,
    seed: 405189962,
    groupIds: ["A_xj1aSIx2HQRUdJYn2ag", "ejMbHDy2o_Y81UiraGhqM", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["kolDJ4SN-0geQFnJ2VFaQ"],
    fontSize: 10.66928372126779,
    fontFamily: 1,
    text: "+ dateAdded: Date",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2626,
    versionNonce: 492111122,
    isDeleted: true,
    id: "EHYEWriGSy9N9Tw4-fkTB",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 23.068892045454504,
    y: 1066.5925473373409,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 476.6883548323558,
    height: 7.620916943762697,
    seed: 2039939907,
    groupIds: ["JRCP7kB-zK1cLMBP65SN2", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.096733555010139,
    fontFamily: 1,
    text:
      "Each document in Users collection has two sub-collections associated which could contain 0 or more documents. Those are Watchlist Items and Notifications.",
    baseline: 5.620916943762697,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1244,
    versionNonce: 1379339534,
    isDeleted: true,
    id: "Ha6r0fuEulSo3LuD15h9W",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 396.85487690270054,
    y: 1066.5813878967551,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 47.24968505132871,
    height: 7.620916943762697,
    seed: 918702733,
    groupIds: ["JRCP7kB-zK1cLMBP65SN2", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.096733555010145,
    fontFamily: 1,
    text: "Watchlist Items",
    baseline: 5.620916943762697,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1315,
    versionNonce: 1515623122,
    isDeleted: true,
    id: "5pbGx_f5Ut4lg9OqM8kaN",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 460.6201295990911,
    y: 1066.4423139284045,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 37.723538871625365,
    height: 7.620916943762697,
    seed: 1203078211,
    groupIds: ["JRCP7kB-zK1cLMBP65SN2", "fpN62_MS6SZ9whiwHY8P4", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.096733555010145,
    fontFamily: 1,
    text: "Notifications",
    baseline: 5.620916943762697,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 5099,
    versionNonce: 170801998,
    isDeleted: true,
    id: "dcLIy07lcwNlnVvxEc_hY",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 619.3898850600233,
    y: 810.8322768766575,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 135.54713869551617,
    height: 166.1774863264371,
    seed: 2099458457,
    groupIds: [
      "0SeKU2WbSbwMpkIKAjrby",
      "tNzYOmdD4VAZQSu3jByiA",
      "MdnFCuy5N0Wf0gGvwY4lb",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4970,
    versionNonce: 593520786,
    isDeleted: true,
    id: "-lf2WDurtV0uolmWvB0f0",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 607.2842924869256,
    y: 798.7813168780658,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 145.38155226615768,
    height: 176.076654700111,
    seed: 886806137,
    groupIds: [
      "0SeKU2WbSbwMpkIKAjrby",
      "tNzYOmdD4VAZQSu3jByiA",
      "MdnFCuy5N0Wf0gGvwY4lb",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ"]
  },
  {
    type: "rectangle",
    version: 4831,
    versionNonce: 262513038,
    isDeleted: true,
    id: "o4Mf4uTX__4-PgfwplqAv",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 595.20539459872,
    y: 786.5160411917136,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 155.36228305759357,
    height: 185.90682377920783,
    seed: 636772185,
    groupIds: [
      "0SeKU2WbSbwMpkIKAjrby",
      "tNzYOmdD4VAZQSu3jByiA",
      "MdnFCuy5N0Wf0gGvwY4lb",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["qn3Fd6CI6z7f4cnBaguxy"]
  },
  {
    type: "text",
    version: 2567,
    versionNonce: 1613334098,
    isDeleted: true,
    id: "h7tJmyNordMB_CP_VAmLs",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 666.1509258524914,
    y: 792.7346494379408,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 24.386934220040597,
    height: 13.33660465158471,
    seed: 388308249,
    groupIds: [
      "yrWCutRYoF9NTGoRpfVzr",
      "MdnFCuy5N0Wf0gGvwY4lb",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267758,
    fontFamily: 1,
    text: "Post",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2928,
    versionNonce: 903233486,
    isDeleted: true,
    id: "NsOcWfrfr3gRLDL2-L4E9",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 601.6033639421735,
    y: 815.0855533637725,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 132.98500066865904,
    height: 146.70265116743207,
    seed: 513020409,
    groupIds: [
      "yrWCutRYoF9NTGoRpfVzr",
      "MdnFCuy5N0Wf0gGvwY4lb",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["J5PrGN4gDtN8MBSoArDXY", "qn3Fd6CI6z7f4cnBaguxy"],
    fontSize: 10.669283721267766,
    fontFamily: 1,
    text:
      "+ author: User\n+ date: Date\n+ commentsCount: Number\n+ images: URL[ ]\n+ keywords:\n  - id: uid\n  - label: String\n+ likes: String[ ]\n+ links: String[ ]\n+ location: String\n+ text: String",
    baseline: 142.70265116743207,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2185,
    versionNonce: 1770581010,
    isDeleted: true,
    id: "AYW8RdQsxUSPBGLKiSTZc",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 959.8147976010828,
    y: 874.6948140118322,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 11.43137541564404,
    height: 17.147063123466065,
    seed: 437501059,
    groupIds: ["XJXpjE_y4GMXwZbYwIhdC", "8-6qQPB_tvGxz4gBjWOQj", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 13.717650498772855,
    fontFamily: 1,
    text: "...",
    baseline: 12.147063123466065,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2376,
    versionNonce: 14226958,
    isDeleted: true,
    id: "xP2UVnonVz1QC3PI3-uh0",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 648.0169540267727,
    y: 758.4706172908288,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 54.10851030071509,
    height: 17.147063123466065,
    seed: 616603287,
    groupIds: ["XJXpjE_y4GMXwZbYwIhdC", "8-6qQPB_tvGxz4gBjWOQj", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 13.717650498772864,
    fontFamily: 1,
    text: "FIRM #1",
    baseline: 12.147063123466065,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2710,
    versionNonce: 1702205906,
    isDeleted: true,
    id: "lytPiNuVagatxJQoFyMoK",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 827.1551646325631,
    y: 760.6616309121507,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 62.11047309166589,
    height: 17.147063123466065,
    seed: 1391355031,
    groupIds: ["XJXpjE_y4GMXwZbYwIhdC", "8-6qQPB_tvGxz4gBjWOQj", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 13.717650498772846,
    fontFamily: 1,
    text: "FIRM #2",
    baseline: 12.147063123466065,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 4439,
    versionNonce: 161948750,
    isDeleted: true,
    id: "ajA553on5zc9OOjYWxJ1M",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 608.9141743566886,
    y: 1039.1714295635327,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 147.8809109717937,
    height: 85.26676165562958,
    seed: 1078945965,
    groupIds: [
      "nL_bof7a_jjcTwNtM7kSB",
      "MSHuDn03A80akWGLE68Hx",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4563,
    versionNonce: 587632530,
    isDeleted: true,
    id: "_d_pdt7-AGi8PtGZ-ny7Z",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 601.2015415131123,
    y: 1031.7007175290198,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 152.0426110126278,
    height: 88.59936491974173,
    seed: 756534029,
    groupIds: [
      "nL_bof7a_jjcTwNtM7kSB",
      "MSHuDn03A80akWGLE68Hx",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ", "qn3Fd6CI6z7f4cnBaguxy"]
  },
  {
    type: "rectangle",
    version: 4705,
    versionNonce: 1645832846,
    isDeleted: true,
    id: "7eShyvtpIuFmsQvbVb4pt",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 593.3473330257805,
    y: 1023.7241451845366,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 156.66810559802815,
    height: 92.69878969580866,
    seed: 2070208877,
    groupIds: [
      "nL_bof7a_jjcTwNtM7kSB",
      "MSHuDn03A80akWGLE68Hx",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["qn3Fd6CI6z7f4cnBaguxy"]
  },
  {
    type: "text",
    version: 3048,
    versionNonce: 1987235154,
    isDeleted: true,
    id: "qVicM5ovsNZhaX-3NtQVj",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 650.2239889972723,
    y: 1034.097915371298,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 44.582364121011764,
    height: 13.33660465158471,
    seed: 8399821,
    groupIds: [
      "uGTqy2-0VvrYNnsQChZ4l",
      "MSHuDn03A80akWGLE68Hx",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["qn3Fd6CI6z7f4cnBaguxy"],
    fontSize: 10.669283721267753,
    fontFamily: 1,
    text: "Comment",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3303,
    versionNonce: 2028529870,
    isDeleted: true,
    id: "l3rOJDwmrX7IUM4ywZ8_R",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 599.3250841345141,
    y: 1055.3504632278068,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 88.78368239483534,
    height: 53.34641860633884,
    seed: 746793517,
    groupIds: [
      "uGTqy2-0VvrYNnsQChZ4l",
      "MSHuDn03A80akWGLE68Hx",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["2eTzultbqtI2zYmfhheWI"],
    fontSize: 10.669283721267767,
    fontFamily: 1,
    text: "+ author: User\n+ date: Date\n+ likes: String[ ]\n+ text: String",
    baseline: 49.34641860633884,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "arrow",
    version: 6075,
    versionNonce: 353456914,
    isDeleted: true,
    id: "qn3Fd6CI6z7f4cnBaguxy",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 675.5131826477715,
    y: 975.505196669131,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 0.8839469412754468,
    height: 47.369670372405174,
    seed: 811031693,
    groupIds: ["XJXpjE_y4GMXwZbYwIhdC", "8-6qQPB_tvGxz4gBjWOQj", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: {
      elementId: "NsOcWfrfr3gRLDL2-L4E9",
      focus: -0.13324337792716068,
      gap: 13.716992137926354
    },
    endBinding: {
      elementId: "qVicM5ovsNZhaX-3NtQVj",
      focus: 0.07941789694672689,
      gap: 11.223048329761923
    },
    points: [
      [0, 0],
      [-0.8839469412754468, 47.369670372405174]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "rectangle",
    version: 5357,
    versionNonce: 2108595982,
    isDeleted: true,
    id: "VlCLJK1x_o7_IqpNlJkWu",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 802.5290770612842,
    y: 811.3817924037403,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 135.54713869551617,
    height: 166.1774863264371,
    seed: 1619443833,
    groupIds: [
      "9X1alHKqmGuhDGB7zI00U",
      "MzLnJBjsoKmTEBPGBVjfw",
      "QIWQhk9BAq7KQyzPmtKST",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 5227,
    versionNonce: 1901666514,
    isDeleted: true,
    id: "6E3Mh9IXKShiCaQzINx20",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 790.4234844881869,
    y: 799.3308324051527,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 145.38155226615768,
    height: 176.076654700111,
    seed: 1185565017,
    groupIds: [
      "9X1alHKqmGuhDGB7zI00U",
      "MzLnJBjsoKmTEBPGBVjfw",
      "QIWQhk9BAq7KQyzPmtKST",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ"]
  },
  {
    type: "rectangle",
    version: 5084,
    versionNonce: 1155763534,
    isDeleted: true,
    id: "NXQPVQLX5tDYTsr-mwKD9",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 778.3445865999879,
    y: 787.0655567188023,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 155.36228305759357,
    height: 185.90682377920783,
    seed: 891926073,
    groupIds: [
      "9X1alHKqmGuhDGB7zI00U",
      "MzLnJBjsoKmTEBPGBVjfw",
      "QIWQhk9BAq7KQyzPmtKST",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["J5PrGN4gDtN8MBSoArDXY"]
  },
  {
    type: "text",
    version: 2826,
    versionNonce: 383858322,
    isDeleted: true,
    id: "K16L-y0i23JbNOPr96yS1",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 849.2249563677367,
    y: 793.135318930965,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 24.386934220040597,
    height: 13.33660465158471,
    seed: 1314536441,
    groupIds: [
      "O5txz1xDd_5hAG73-OtmH",
      "QIWQhk9BAq7KQyzPmtKST",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267758,
    fontFamily: 1,
    text: "Post",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3186,
    versionNonce: 736146318,
    isDeleted: true,
    id: "b3R6h044ZQEH_M3QODDz7",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 784.6773944574193,
    y: 815.4862228567852,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 132.98500066865904,
    height: 146.70265116743207,
    seed: 864179417,
    groupIds: [
      "O5txz1xDd_5hAG73-OtmH",
      "QIWQhk9BAq7KQyzPmtKST",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["J5PrGN4gDtN8MBSoArDXY"],
    fontSize: 10.669283721267766,
    fontFamily: 1,
    text:
      "+ author: User\n+ date: Date\n+ commentsCount: Number\n+ images: URL[ ]\n+ keywords:\n  - id: uid\n  - label: String\n+ likes: String[ ]\n+ links: String[ ]\n+ location: String\n+ text: String",
    baseline: 142.70265116743207,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 4568,
    versionNonce: 106992722,
    isDeleted: true,
    id: "Bl3Q5FHpZbIFWPBGcY6Dx",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 792.0533663579583,
    y: 1039.0614129296607,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 147.8809109717937,
    height: 85.26676165562958,
    seed: 1128728151,
    groupIds: [
      "Q9BFpuvAPYMCUerZy1Zuy",
      "pj9aMPQBn424v9cmzFgwQ",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4691,
    versionNonce: 2094993870,
    isDeleted: true,
    id: "YVUngr91S83pwfCxziL5x",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 784.340733514377,
    y: 1031.590700895152,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 152.0426110126278,
    height: 88.59936491974173,
    seed: 1028943513,
    groupIds: [
      "Q9BFpuvAPYMCUerZy1Zuy",
      "pj9aMPQBn424v9cmzFgwQ",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ", "J5PrGN4gDtN8MBSoArDXY"]
  },
  {
    type: "rectangle",
    version: 4840,
    versionNonce: 296630802,
    isDeleted: true,
    id: "Bx6T1FpYDY-9tNKQQaGrp",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 776.4865250270498,
    y: 1023.6141285506587,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 156.66810559802815,
    height: 92.69878969580866,
    seed: 1130505079,
    groupIds: [
      "Q9BFpuvAPYMCUerZy1Zuy",
      "pj9aMPQBn424v9cmzFgwQ",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["J5PrGN4gDtN8MBSoArDXY"]
  },
  {
    type: "text",
    version: 3177,
    versionNonce: 1391962126,
    isDeleted: true,
    id: "p_bsydbK5d-BBLusYD_qz",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 833.3631809985363,
    y: 1033.9878987374243,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 44.582364121011764,
    height: 13.33660465158471,
    seed: 140287127,
    groupIds: [
      "tFpiz4fKZyDsws8mNryoT",
      "pj9aMPQBn424v9cmzFgwQ",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["J5PrGN4gDtN8MBSoArDXY"],
    fontSize: 10.669283721267753,
    fontFamily: 1,
    text: "Comment",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3431,
    versionNonce: 935405522,
    isDeleted: true,
    id: "yLiwy7QI3g5HPMh1kWoiX",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 782.4642761357748,
    y: 1055.2404465939348,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 88.78368239483534,
    height: 53.34641860633884,
    seed: 783965273,
    groupIds: [
      "tFpiz4fKZyDsws8mNryoT",
      "pj9aMPQBn424v9cmzFgwQ",
      "XJXpjE_y4GMXwZbYwIhdC",
      "8-6qQPB_tvGxz4gBjWOQj",
      "C_4jvHPY-Ve2de2RC7p1L",
      "1scXQKZyMHLqY4ZkebLw3"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["2eTzultbqtI2zYmfhheWI"],
    fontSize: 10.669283721267767,
    fontFamily: 1,
    text: "+ author: User\n+ date: Date\n+ likes: String[ ]\n+ text: String",
    baseline: 49.34641860633884,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "arrow",
    version: 6424,
    versionNonce: 2116253262,
    isDeleted: true,
    id: "J5PrGN4gDtN8MBSoArDXY",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 858.2104011783949,
    y: 975.2941804150057,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 0,
    height: 47.25096381161071,
    seed: 1487805241,
    groupIds: ["XJXpjE_y4GMXwZbYwIhdC", "8-6qQPB_tvGxz4gBjWOQj", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: {
      elementId: "b3R6h044ZQEH_M3QODDz7",
      focus: -0.1058842177876591,
      gap: 13.105306390788428
    },
    endBinding: {
      elementId: "p_bsydbK5d-BBLusYD_qz",
      focus: 0.11466588503089455,
      gap: 11.442754510807845
    },
    points: [
      [0, 0],
      [0, 47.25096381161071]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "text",
    version: 2232,
    versionNonce: 11558290,
    isDeleted: true,
    id: "BbJHAGwJCtQV-ECPAa30e",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 959.1546977978737,
    y: 1065.397620006251,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 11.43137541564404,
    height: 17.147063123466065,
    seed: 482113753,
    groupIds: ["XJXpjE_y4GMXwZbYwIhdC", "8-6qQPB_tvGxz4gBjWOQj", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 13.717650498772855,
    fontFamily: 1,
    text: "...",
    baseline: 12.147063123466065,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3111,
    versionNonce: 1731951758,
    isDeleted: true,
    id: "dSIKF-9kI8bJVWQOn6_X4",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 545.6413956506344,
    y: 1141.5322136166587,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 473.25894220766327,
    height: 15.241833887525393,
    seed: 2084933571,
    groupIds: ["UemChN2WzStJQlLik9yed", "8-6qQPB_tvGxz4gBjWOQj", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.096733555010148,
    fontFamily: 1,
    text:
      "The application is used by different clients so we need independent post collections so users from each company would see only posts from their colleagues.\nEach Post has a associated sub-collection Comments.",
    baseline: 13.241833887525393,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1271,
    versionNonce: 1504893778,
    isDeleted: true,
    id: "YuyUAwwpeiabtOwyoi0JI",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 832.9017571653583,
    y: 1149.1594384666641,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 28.5784385391101,
    height: 7.620916943762697,
    seed: 199087853,
    groupIds: ["UemChN2WzStJQlLik9yed", "8-6qQPB_tvGxz4gBjWOQj", "C_4jvHPY-Ve2de2RC7p1L", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.09673355501015,
    fontFamily: 1,
    text: "Comments",
    baseline: 5.620916943762697,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1653,
    versionNonce: 1945680590,
    isDeleted: true,
    id: "bagtmZqPHrOHqTuqXQpR1",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 431.20225941492185,
    y: 236.93762694683022,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 180.1425839120082,
    height: 26.82974654008634,
    seed: 464435853,
    groupIds: ["EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 21.46379723206903,
    fontFamily: 1,
    text: "ARCHITECTURE",
    baseline: 18.82974654008634,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 1939,
    versionNonce: 1897898258,
    isDeleted: true,
    id: "SET7V1OooI3LsgFL7t-RO",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 295.1944082744724,
    y: 390.5198126068664,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 280.62438954376177,
    height: 94.47895693227242,
    seed: 352672265,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["fIR0c5py93ZEN3l8mgap-", "HkC0JYolTVFg4m0AbEY2Q"]
  },
  {
    type: "text",
    version: 1645,
    versionNonce: 1794388238,
    isDeleted: true,
    id: "e3gwt311Dsv1K1o1WtlYU",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 325.71433233902883,
    y: 418.131318957113,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 47.63073089851689,
    height: 13.33660465158471,
    seed: 2044406729,
    groupIds: ["Jz26f1Vx30avhNv2RUjXB", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267782,
    fontFamily: 1,
    text: "Firestore",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1741,
    versionNonce: 309178066,
    isDeleted: true,
    id: "hMvX7otZ5jqfChJtbQlFL",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 307.42413167399764,
    y: 437.45323527535066,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 84.2111322285778,
    height: 19.052292359406728,
    seed: 1737233097,
    groupIds: ["Jz26f1Vx30avhNv2RUjXB", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["HkC0JYolTVFg4m0AbEY2Q"],
    fontSize: 7.620916943762705,
    fontFamily: 1,
    text: "(Real Time\nnon-relation database)",
    baseline: 16.052292359406728,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 1264,
    versionNonce: 1470553934,
    isDeleted: true,
    id: "gdii3djRdXmKCPYF1VKsC",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 319.99769673185267,
    y: 339.46882699228564,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 92.57798044016202,
    height: 28.134026808851633,
    seed: 686808839,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["fTpPNQKiM0r2zSoL2WpL7"]
  },
  {
    type: "text",
    version: 1870,
    versionNonce: 36963474,
    isDeleted: true,
    id: "I9n_zMEnMFQ9doClqrcSo",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 330.8775403206031,
    y: 344.7026701443098,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 73.54184850730996,
    height: 13.33660465158471,
    seed: 2050190697,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["fTpPNQKiM0r2zSoL2WpL7"],
    fontSize: 10.66928372126778,
    fontFamily: 1,
    text: "Authentication",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 5966,
    versionNonce: 1852425614,
    isDeleted: true,
    id: "w3PU_FJoZLBv-yJp-i3l6",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 437.58933930576825,
    y: 461.263354988141,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 41.98391275615873,
    height: 54.18690467838429,
    seed: 1478208909,
    groupIds: ["xMNrY3R3BxXs_EElA_98y", "lu_WQG8EDGmrIsy36JSus", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [-0.2531410570138488, -48.171888682094355],
      [-0.11469967335573157, -7.217719823265176],
      [-0.24666232525498905, -2.555265540580738],
      [1.9091233035075623, -0.5406766993867884],
      [9.416539188943593, 1.1643177844761037],
      [22.106198641938274, 1.6952275969276325],
      [34.23032910514416, 0.8475523118396681],
      [40.671968888266804, -1.1796478010984606],
      [41.58047501353344, -2.888598762371472],
      [41.70807141000515, -6.6423067050895375],
      [41.60792307556513, -44.736062503853546],
      [41.38215658335813, -48.3352205477442],
      [38.68636583837122, -50.3468136545058],
      [33.00960583475534, -51.51182193972771],
      [20.073036787766103, -52.49167708145666],
      [9.70118936151074, -51.90738725411288],
      [1.5438017997064004, -49.92554745202707],
      [-0.2758413461535838, -48.19649655855677],
      [-0.2531410570138488, -48.171888682094355]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 3699,
    versionNonce: 1512677970,
    isDeleted: true,
    id: "B04qoVi78xUW-Adfh8hjU",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 437.34282739391745,
    y: 446.5034737904843,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 42.02746148320589,
    height: 4.663010858574028,
    seed: 281572333,
    groupIds: ["xMNrY3R3BxXs_EElA_98y", "lu_WQG8EDGmrIsy36JSus", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.3898574736260807],
      [1.1072431533376497, -0.5311034166928754],
      [5.882325113448745, 1.028374155370748],
      [12.236319547933526, 1.9727843434079881],
      [22.190645393383985, 2.058844191907399],
      [33.807002062979514, 1.45758084119745],
      [40.59108563290933, -0.7298016557697927],
      [42.02746148320589, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 3785,
    versionNonce: 1886774222,
    isDeleted: true,
    id: "S-dsBN2eLbe7PDvZLwgQh",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 436.8746097054934,
    y: 430.78987605115384,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 42.02746148320589,
    height: 4.663010858574028,
    seed: 2026729037,
    groupIds: ["xMNrY3R3BxXs_EElA_98y", "lu_WQG8EDGmrIsy36JSus", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.3898574736260807],
      [1.1072431533376497, -0.5311034166928754],
      [5.882325113448745, 1.028374155370748],
      [12.236319547933526, 1.9727843434079881],
      [22.190645393383985, 2.058844191907399],
      [33.807002062979514, 1.45758084119745],
      [40.59108563290933, -0.7298016557697927],
      [42.02746148320589, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "ellipse",
    version: 6805,
    versionNonce: 1696958482,
    isDeleted: true,
    id: "dg0TzG41yVw5BTug0EuMa",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 436.3000642195635,
    y: 409.1855826367252,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 41.71462106405,
    height: 8.436468278223897,
    seed: 1594105005,
    groupIds: ["xMNrY3R3BxXs_EElA_98y", "lu_WQG8EDGmrIsy36JSus", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["bxuMGTzXLn7H-uBCptINx"]
  },
  {
    type: "ellipse",
    version: 2211,
    versionNonce: 266615310,
    isDeleted: true,
    id: "-TsuQ9HcpumpMj9txdBuB",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 470.33287646301983,
    y: 420.8816645285406,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 6.1136775860223915,
    height: 6.635211714789229,
    seed: 2065039117,
    groupIds: ["xMNrY3R3BxXs_EElA_98y", "lu_WQG8EDGmrIsy36JSus", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["z0CySNXkHqz6qvQf3kBBn"]
  },
  {
    type: "ellipse",
    version: 2222,
    versionNonce: 2065610194,
    isDeleted: true,
    id: "ot_SY5hNgst8Hh7SZ-Rru",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 470.33287646301983,
    y: 435.44594176560764,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 6.1136775860223915,
    height: 6.635211714789229,
    seed: 1400673645,
    groupIds: ["xMNrY3R3BxXs_EElA_98y", "lu_WQG8EDGmrIsy36JSus", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 2292,
    versionNonce: 1403897934,
    isDeleted: true,
    id: "9A3uJfT-5ZcCBmKZYmYZi",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 470.33287646301983,
    y: 451.2753759561912,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 6.1136775860223915,
    height: 6.635211714789229,
    seed: 1669423053,
    groupIds: ["xMNrY3R3BxXs_EElA_98y", "lu_WQG8EDGmrIsy36JSus", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["SbdFT-onqasPJsrbbhTiu"]
  },
  {
    type: "text",
    version: 1533,
    versionNonce: 1563175826,
    isDeleted: true,
    id: "y7BMSDDzJUJPvHa90bsYA",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 445.8969051429558,
    y: 434.9572999213935,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 21.338567442535535,
    height: 9.526146179703364,
    seed: 748141261,
    groupIds: ["lu_WQG8EDGmrIsy36JSus", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762679,
    fontFamily: 1,
    text: "Users",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 6146,
    versionNonce: 2074840718,
    isDeleted: true,
    id: "-Vt7jXBrpMcqZlx81OfWf",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 513.1682676981857,
    y: 461.21770779710533,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 41.98391275615873,
    height: 54.18690467838429,
    seed: 333541283,
    groupIds: ["5v-TMtGPLHQ08h7xvVgEv", "ue3zGfuYcpEavd6KyA1dY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [-0.2531410570138488, -48.171888682094355],
      [-0.11469967335573157, -7.217719823265176],
      [-0.24666232525498905, -2.555265540580738],
      [1.9091233035075623, -0.5406766993867884],
      [9.416539188943593, 1.1643177844761037],
      [22.106198641938274, 1.6952275969276325],
      [34.23032910514416, 0.8475523118396681],
      [40.671968888266804, -1.1796478010984606],
      [41.58047501353344, -2.888598762371472],
      [41.70807141000515, -6.6423067050895375],
      [41.60792307556513, -44.736062503853546],
      [41.38215658335813, -48.3352205477442],
      [38.68636583837122, -50.3468136545058],
      [33.00960583475534, -51.51182193972771],
      [20.073036787766103, -52.49167708145666],
      [9.70118936151074, -51.90738725411288],
      [1.5438017997064004, -49.92554745202707],
      [-0.2758413461535838, -48.19649655855677],
      [-0.2531410570138488, -48.171888682094355]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 3877,
    versionNonce: 293923154,
    isDeleted: true,
    id: "azrSX5nlXJvxpyaMseaeO",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 512.9217557863349,
    y: 446.47060630944674,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 42.02746148320589,
    height: 4.663010858574028,
    seed: 33129283,
    groupIds: ["5v-TMtGPLHQ08h7xvVgEv", "ue3zGfuYcpEavd6KyA1dY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.3898574736260807],
      [1.1072431533376497, -0.5311034166928754],
      [5.882325113448745, 1.028374155370748],
      [12.236319547933526, 1.9727843434079881],
      [22.190645393383985, 2.058844191907399],
      [33.807002062979514, 1.45758084119745],
      [40.59108563290933, -0.7298016557697927],
      [42.02746148320589, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 3963,
    versionNonce: 1687588046,
    isDeleted: true,
    id: "dGG4HnyKgFKyzSj7wbTwX",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 512.4535380979175,
    y: 430.757008570109,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 42.02746148320589,
    height: 4.663010858574028,
    seed: 118366947,
    groupIds: ["5v-TMtGPLHQ08h7xvVgEv", "ue3zGfuYcpEavd6KyA1dY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.3898574736260807],
      [1.1072431533376497, -0.5311034166928754],
      [5.882325113448745, 1.028374155370748],
      [12.236319547933526, 1.9727843434079881],
      [22.190645393383985, 2.058844191907399],
      [33.807002062979514, 1.45758084119745],
      [40.59108563290933, -0.7298016557697927],
      [42.02746148320589, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "ellipse",
    version: 6982,
    versionNonce: 1065348882,
    isDeleted: true,
    id: "T374V7bhaDPOn5ub0cDkO",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 511.8789926119814,
    y: 409.1527151556822,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 41.71462106405,
    height: 8.436468278223897,
    seed: 732810883,
    groupIds: ["5v-TMtGPLHQ08h7xvVgEv", "ue3zGfuYcpEavd6KyA1dY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["bxuMGTzXLn7H-uBCptINx"]
  },
  {
    type: "ellipse",
    version: 2351,
    versionNonce: 1812448014,
    isDeleted: true,
    id: "zNos3mFS_TcQFdSPyGzPP",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 545.9118048554349,
    y: 420.84879704750307,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 6.1136775860223915,
    height: 6.635211714789229,
    seed: 1654064675,
    groupIds: ["5v-TMtGPLHQ08h7xvVgEv", "ue3zGfuYcpEavd6KyA1dY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 2431,
    versionNonce: 194264274,
    isDeleted: true,
    id: "dHRpdOe6EZCmNshRFoN1e",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 545.9118048554349,
    y: 435.41307428456895,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 6.1136775860223915,
    height: 6.635211714789229,
    seed: 1119373763,
    groupIds: ["5v-TMtGPLHQ08h7xvVgEv", "ue3zGfuYcpEavd6KyA1dY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["zY80ErBY28YbIfLuW1hlY"]
  },
  {
    type: "ellipse",
    version: 2454,
    versionNonce: 1417163086,
    isDeleted: true,
    id: "SUVCP3nAHiYfnbt2FYMhI",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 545.9118048554349,
    y: 451.24250847514935,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 6.1136775860223915,
    height: 6.635211714789229,
    seed: 19929443,
    groupIds: ["5v-TMtGPLHQ08h7xvVgEv", "ue3zGfuYcpEavd6KyA1dY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "text",
    version: 1694,
    versionNonce: 1935200914,
    isDeleted: true,
    id: "y-5HViRUhe-ccgcsuYr8x",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 521.3751637862225,
    y: 435.137048153359,
    strokeColor: "#000000",
    backgroundColor: "#1ca9b0",
    width: 21.338567442535535,
    height: 9.526146179703364,
    seed: 707395245,
    groupIds: ["ue3zGfuYcpEavd6KyA1dY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["zY80ErBY28YbIfLuW1hlY"],
    fontSize: 7.620916943762679,
    fontFamily: 1,
    text: "Posts",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 3092,
    versionNonce: 692115342,
    isDeleted: true,
    id: "2pDQ2Vsyr_u4utHfGjDdE",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 145.870868010815,
    y: 420.2885707723121,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 58.382788336969526,
    height: 34.94144060137221,
    seed: 1582524643,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["5r80FV_Cc6QA7hBBEbjH9", "HkC0JYolTVFg4m0AbEY2Q"]
  },
  {
    type: "line",
    version: 2806,
    versionNonce: 696561746,
    isDeleted: true,
    id: "ineZMqhoNQ-0SbyQXF2Hq",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 144.87467398390228,
    y: 424.50482797696867,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 58.820188018616186,
    height: 0,
    seed: 1906199245,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [58.820188018616186, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "ellipse",
    version: 2639,
    versionNonce: 580564430,
    isDeleted: true,
    id: "oQtbBut4WfLz5joUjeA1P",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 147.91979016999468,
    y: 422.238669892136,
    strokeColor: "#000000",
    backgroundColor: "#fa5252",
    width: 2.283540909579772,
    height: 2.283540909579772,
    seed: 911889539,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 2684,
    versionNonce: 1911477778,
    isDeleted: true,
    id: "i1ASC3C6rYMLwpSmZD-gN",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 152.6050169210265,
    y: 422.238669892136,
    strokeColor: "#000000",
    backgroundColor: "#fab005",
    width: 2.283540909579772,
    height: 2.283540909579772,
    seed: 847604013,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 2739,
    versionNonce: 161401870,
    isDeleted: true,
    id: "8WNPWGNFcI5UtfPJSL9hV",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 157.4833594198933,
    y: 422.4444375528697,
    strokeColor: "#000000",
    backgroundColor: "#40c057",
    width: 2.283540909579772,
    height: 2.283540909579772,
    seed: 834849827,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 3015,
    versionNonce: 2106475474,
    isDeleted: true,
    id: "yn8NmHML-9uWPKeCNgAOK",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 164.8001911685185,
    y: 429.7728231079869,
    strokeColor: "#000000",
    backgroundColor: "#1ca9b0",
    width: 19.503047654849453,
    height: 19.503047654849453,
    seed: 1505344397,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "draw",
    version: 3643,
    versionNonce: 474356302,
    isDeleted: true,
    id: "vNwtKmnqpCJ7Ntzgcag5o",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 182.01893783392495,
    y: 437.96098039735233,
    strokeColor: "#087f5b",
    backgroundColor: "#40c057",
    width: 12.886103756172135,
    height: 11.158102143878796,
    seed: 75190211,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [-4.562176204533219, -1.3653855020611372],
      [-5.397883252895959, -1.5546803922078596],
      [-8.019134539663526, -4.228569719133945],
      [-9.747301876240483, -3.3502097477000023],
      [-10.319823570566566, -0.2818900638991398],
      [-9.706763847775123, 1.7116464988594369],
      [-12.516984713388897, 2.6913861604138045],
      [-12.415951473213733, 4.863129209712191],
      [-10.214424696556625, 4.72927633760009],
      [-8.531784684256186, 2.961467991125268],
      [-6.214880441966963, 6.791719408487355],
      [-4.7517694453558015, 6.929532424744851],
      [-6.28660156925182, 0.8261582679638912],
      [-3.9291592984972814, 0.6194387435777272],
      [-3.118398729190153, 1.3132559978393463],
      [-0.34559758215977754, 1.3132559978393463],
      [0.36911904278323787, -1.075502950623057],
      [-2.6350606974878157, -0.8584870514590288],
      [-2.057549707350605, -3.9949212145595494],
      [-3.4333480272671593, -3.805626324412824],
      [-4.670693388425099, -1.7867448391241332],
      [-4.562176204533219, -1.3653855020611372]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 3066,
    versionNonce: 1182398866,
    isDeleted: true,
    id: "FPW_REtmA8llmG74sIp7q",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 164.56047747446598,
    y: 438.570264971751,
    strokeColor: "#000000",
    backgroundColor: "#99bcff",
    width: 19.21767688686214,
    height: 0,
    seed: 259310061,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [19.21767688686214, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 5263,
    versionNonce: 1902747790,
    isDeleted: true,
    id: "ntY4N0_U4beoJjh4wbvzA",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 167.60985459824468,
    y: 434.7495524172895,
    strokeColor: "#000000",
    backgroundColor: "#99bcff",
    width: 13.384819073402216,
    height: 2.607333247667313,
    seed: 1621253987,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.48433518719834],
      [0.35263251109301436, -1.4450085808262816],
      [1.8733907449038723, -0.5730231074955923],
      [3.896997760354183, -0.04495398611088653],
      [7.067230882625615, 0.0031665810006841376],
      [10.766784146787831, -0.3330312037686874],
      [12.927365061212946, -1.556111155153665],
      [13.384819073402216, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "ellipse",
    version: 3079,
    versionNonce: 1810429778,
    isDeleted: true,
    id: "uoFnPu3haNkMndhEMM9-1",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 171.30849013633912,
    y: 429.1416570636413,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 7.089193805082788,
    height: 20.46271966504804,
    seed: 952106061,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["vsWSl8B5nlA9K0hSLAPFk"]
  },
  {
    type: "line",
    version: 5469,
    versionNonce: 1556242126,
    isDeleted: true,
    id: "wgFgW55ZFtrOfqt5Xfezq",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 168.3145836263492,
    y: 449.84267143623975,
    strokeColor: "#000000",
    backgroundColor: "#99bcff",
    width: 13.384819073402216,
    height: 2.691728009486165,
    seed: 814119683,
    groupIds: ["aZE1GB28tOOgeF4Yp6JfY", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -3.0570641059681067],
      [1.8733907449038723, -5.0302419743544675],
      [3.896997760354183, -5.575403758429325],
      [7.067230882625615, -5.625081903117008],
      [10.766784146787831, -5.278001991179935],
      [12.927365061212946, -4.015333106821062],
      [13.384819073402216, -2.933353893630842]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "text",
    version: 1670,
    versionNonce: 238173458,
    isDeleted: true,
    id: "zZGTrFN0wa8SKFRo3u-g7",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 148.78927362585029,
    y: 461.3099296623869,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 50.67909767602192,
    height: 13.33660465158471,
    seed: 1490213037,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267773,
    fontFamily: 1,
    text: "Front end",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "arrow",
    version: 2686,
    versionNonce: 1391023374,
    isDeleted: true,
    id: "HkC0JYolTVFg4m0AbEY2Q",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 294.806558037155,
    y: 437.7525269686652,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 89.28805781309993,
    height: 0.013528208673301054,
    seed: 285578765,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: {
      elementId: "hMvX7otZ5jqfChJtbQlFL",
      focus: 0.9688036528735245,
      gap: 12.617573636842593
    },
    endBinding: {
      elementId: "2pDQ2Vsyr_u4utHfGjDdE",
      focus: 0.0006511299264140945,
      gap: 1.2648438762705752
    },
    points: [
      [0, 0],
      [-89.28805781309993, 0.013528208673301054]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "rectangle",
    version: 1497,
    versionNonce: 718064338,
    isDeleted: true,
    id: "NZmoRL6ECJ5WbBWx7c5uZ",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 607.4794845880597,
    y: 309.33173296429396,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 290.07015886507367,
    height: 268.7623529362437,
    seed: 1416556963,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "text",
    version: 1797,
    versionNonce: 1297580878,
    isDeleted: true,
    id: "K7F1lYvFekZrlTYJkctiw",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 797.6939339733267,
    y: 444.81057288469725,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 76.20916943762691,
    height: 13.33660465158471,
    seed: 1363452717,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 10.669283721267776,
    fontFamily: 1,
    text: "Cloud Storage",
    baseline: 9.33660465158471,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1888,
    versionNonce: 2018484370,
    isDeleted: true,
    id: "A5BX3WGvg3Uwkzk-mDrlR",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 800.3090439429538,
    y: 464.47719883973474,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 70.53587293187583,
    height: 11.450628722707103,
    seed: 783724333,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.160502978165704,
    fontFamily: 1,
    text: "(Static assets)",
    baseline: 8.450628722707103,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 5718,
    versionNonce: 778430862,
    isDeleted: true,
    id: "0Cxwza7PB8wMVlzJwVmEW",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 664.4580178844847,
    y: 495.31868154344204,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 26.931779657545214,
    height: 40.86747910902242,
    seed: 1319556003,
    groupIds: ["_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["CFu0B4Mw_1wC1Hbgx8Fs0", "XIl_NhaFtRO00pX5Pq6VU", "EndiSTFlx1AT7vcBVjgve", "lKlhz_qvG1GPuEguDcXDI"]
  },
  {
    type: "rectangle",
    version: 5784,
    versionNonce: 1114750546,
    isDeleted: true,
    id: "KhCbRXbd3yLifjIsIMWPR",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 661.5820998692964,
    y: 492.643705674231,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 26.931779657545214,
    height: 40.86747910902242,
    seed: 1922821133,
    groupIds: ["IoeLKkTJ6-srVhjprUyY7", "_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["CFu0B4Mw_1wC1Hbgx8Fs0", "XIl_NhaFtRO00pX5Pq6VU", "EndiSTFlx1AT7vcBVjgve", "lKlhz_qvG1GPuEguDcXDI"]
  },
  {
    type: "rectangle",
    version: 5899,
    versionNonce: 625838030,
    isDeleted: true,
    id: "l74SjqMpWaqpqgE9kotj_",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 658.0021401130102,
    y: 489.4985889745868,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 26.931779657545214,
    height: 40.86747910902242,
    seed: 108160835,
    groupIds: ["_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["CFu0B4Mw_1wC1Hbgx8Fs0", "XIl_NhaFtRO00pX5Pq6VU", "EndiSTFlx1AT7vcBVjgve", "lKlhz_qvG1GPuEguDcXDI"]
  },
  {
    type: "draw",
    version: 4987,
    versionNonce: 1175069714,
    isDeleted: true,
    id: "mHPvXy74wpHMm_lq3s801",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 668.678208541776,
    y: 502.9496550581986,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 17.749053016129434,
    height: 1.2383814159198945,
    seed: 498917997,
    groupIds: ["_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -1.3126835619476387],
      [15.40358454906643, -1.252709592852051],
      [17.749053016129434, -2.491091008771946]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5011,
    versionNonce: 304569870,
    isDeleted: true,
    id: "9icMaOTJa9zPj6pEQTOgy",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 668.5976017204091,
    y: 494.8651863034461,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 17.363274512217238,
    height: 1.0681850171350957,
    seed: 1389004515,
    groupIds: ["_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -1.7351128668796234],
      [6.4139728570615455, -2.8032978840147194],
      [17.363274512217238, -1.85992355932177]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5037,
    versionNonce: 219140562,
    isDeleted: true,
    id: "lVnKWV1xRaeP_ynYGc-0C",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 666.1670066628972,
    y: 515.7487411665511,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 18.41849218468295,
    height: 1.6311267707471269,
    seed: 2049969357,
    groupIds: ["_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -1.216422070558957],
      [10.06428038147468, -1.3136771555788271],
      [14.334946065445418, -0.3341594544649301],
      [18.41849218468295, -1.9652862252120569]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5074,
    versionNonce: 1777101902,
    isDeleted: true,
    id: "h49CXJImzlrIXS-Fqm4yZ",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 667.7258011467411,
    y: 515.344168696266,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 20.731542290072582,
    height: 1.1087079692267154,
    seed: 171815555,
    groupIds: ["_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -1.4217920305235296],
      [3.8737475390580625, -1.8663362837706463],
      [6.146521373256827, -1.7427338110891666],
      [17.62748415985458, -1.1883798264758072],
      [20.731542290072582, -2.297087795702523]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5041,
    versionNonce: 1251592082,
    isDeleted: true,
    id: "YVEGO54IQuRbiMxdsYfys",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 665.2114448634509,
    y: 493.8776459056646,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 17.881968298989936,
    height: 0.9433743246929459,
    seed: 126806829,
    groupIds: ["_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -0.36597980044957573],
      [6.932666643834265, -0.5912874140789839],
      [17.881968298989936, 0.3520869106139621]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5055,
    versionNonce: 443921038,
    isDeleted: true,
    id: "5TYD_C8y5M33wKi8tk6GK",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 664.7696340087018,
    y: 511.79149495364084,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 17.881968298989936,
    height: 0.9433743246929459,
    seed: 764045859,
    groupIds: ["_VyW6IF50kPNbjA10d34e", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -0.36597980044957573],
      [3.0841615023557685, 0.17814234898285045],
      [6.932666643834265, -0.5912874140789839],
      [17.881968298989936, 0.3520869106139621]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "text",
    version: 1452,
    versionNonce: 920585554,
    isDeleted: true,
    id: "i6A71cxHjbwD2aRrUXPmm",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 646.4466923888779,
    y: 545.2323053540297,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 57.1568770782202,
    height: 9.526146179703364,
    seed: 1365437635,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.6209169437627,
    fontFamily: 1,
    text: "Suppliers config",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1555,
    versionNonce: 1853632718,
    isDeleted: true,
    id: "1Qi667Pj8t9teeLeHQ2Fh",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 743.6135711839363,
    y: 384.2998789251438,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 54.489556147903215,
    height: 9.526146179703364,
    seed: 1455361069,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["RS83Gyl3NcFtAx_OBFWTb"],
    fontSize: 7.620916943762698,
    fontFamily: 1,
    text: "Suppliers logos",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1776,
    versionNonce: 1798736658,
    isDeleted: true,
    id: "eIMeovqdZ6-Uh050Li0-a",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 646.7980665816258,
    y: 383.2262112577385,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 50.29805182883381,
    height: 9.526146179703364,
    seed: 499944643,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762697,
    fontFamily: 1,
    text: "User avatars",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1864,
    versionNonce: 1905846030,
    isDeleted: true,
    id: "F2hQdXfnX8wyDFUpDrneD",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 649.5653269919469,
    y: 463.61634336457445,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 44.963409968199855,
    height: 9.526146179703364,
    seed: 1579475203,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762676,
    fontFamily: 1,
    text: "Post images",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 1521,
    versionNonce: 1041717458,
    isDeleted: true,
    id: "qSSu4iKj3iTqBmtcIpkE-",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 770.8712923912822,
    y: 393.6993197029124,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 119.27909486500525,
    seed: 1552246659,
    groupIds: ["2RRYXmbNEeQSxspQzO9TI", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [0, 119.27909486500525]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 2752,
    versionNonce: 1413797198,
    isDeleted: true,
    id: "lKlhz_qvG1GPuEguDcXDI",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 770.904195332274,
    y: 512.7799523843689,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 78.53231904423036,
    height: 0,
    seed: 2060113603,
    groupIds: ["2RRYXmbNEeQSxspQzO9TI", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [-78.53231904423036, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 1534,
    versionNonce: 521694866,
    isDeleted: true,
    id: "b7f0Arf0xf1vVSoDfT1Yj",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 657.5198336068157,
    y: 512.7536538698143,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 199.72539794929892,
    height: 0,
    seed: 1095216099,
    groupIds: ["ONKLutQbbXND6SlPW8Mt-", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [-199.72539794929892, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 1520,
    versionNonce: 1339620238,
    isDeleted: true,
    id: "SbdFT-onqasPJsrbbhTiu",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 457.8246746337145,
    y: 513.0435029173846,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 49.33832775581967,
    seed: 607373315,
    groupIds: ["ONKLutQbbXND6SlPW8Mt-", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "9A3uJfT-5ZcCBmKZYmYZi",
      focus: 5.091874866905853,
      gap: 14.912149248998883
    },
    points: [
      [0, 0],
      [0, -49.33832775581967]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "arrow",
    version: 1592,
    versionNonce: 1928383570,
    isDeleted: true,
    id: "4ho6KcckvSX7GPBf33od1",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 448.28075977396054,
    y: 353.4141684177966,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 59.80063071981141,
    seed: 391050307,
    groupIds: ["sJ2V_vUXBe1nHuvY_hAMf", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [0, 59.80063071981141]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 1136,
    versionNonce: 177101262,
    isDeleted: true,
    id: "vtBB4YLbEjj6I57r2bjh0",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 448.624625270054,
    y: 353.5358403967063,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 35.6315040068272,
    height: 0,
    seed: 1332342957,
    groupIds: ["sJ2V_vUXBe1nHuvY_hAMf", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [-35.6315040068272, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 2600,
    versionNonce: 1870098962,
    isDeleted: true,
    id: "z0CySNXkHqz6qvQf3kBBn",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 466.95388707630605,
    y: 353.51115070656266,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 60.01188570407863,
    seed: 2114634061,
    groupIds: ["Oif9KKvcpx-PsDX40ZCqF", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "-TsuQ9HcpumpMj9txdBuB",
      focus: -2.105386844225844,
      gap: 9.217972701079468
    },
    points: [
      [0, 0],
      [0, 60.01188570407863]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 1281,
    versionNonce: 2071851022,
    isDeleted: true,
    id: "UaLsXCvJ2OLwij7dSGBsi",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 466.7381330758535,
    y: 353.5358403967063,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 172.7270122172889,
    height: 0,
    seed: 2130343427,
    groupIds: ["Oif9KKvcpx-PsDX40ZCqF", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [172.7270122172889, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 2602,
    versionNonce: 2007195602,
    isDeleted: true,
    id: "zY80ErBY28YbIfLuW1hlY",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 639.4065851674964,
    y: 436.3164792636889,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 84.03176318980775,
    height: 0.37050380808180716,
    seed: 946017677,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: {
      elementId: "-wJUS3WhfLEC6c7Tg6g78",
      focus: -0.022521692243640326,
      gap: 1
    },
    endBinding: {
      elementId: "y-5HViRUhe-ccgcsuYr8x",
      focus: -0.843433391610589,
      gap: 12.66109074893052
    },
    points: [
      [0, 0],
      [-84.03176318980775, -0.37050380808180716]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 1386,
    versionNonce: 1319157326,
    isDeleted: true,
    id: "wt1icNs5tiFbAqeXl6ZRU",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 174.8291977449839,
    y: 420.23597327794613,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 66.50936203404636,
    seed: 658675715,
    groupIds: ["YnEqU2Wlx4twgl3u7gRdS", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [0, -66.50936203404636]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 1987,
    versionNonce: 2005636498,
    isDeleted: true,
    id: "fTpPNQKiM0r2zSoL2WpL7",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 174.69703495046377,
    y: 353.6237990321917,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 144.8798313508311,
    height: 0,
    seed: 726955821,
    groupIds: ["YnEqU2Wlx4twgl3u7gRdS", "6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "I9n_zMEnMFQ9doClqrcSo",
      focus: -0.33784109538282436,
      gap: 11.30067401930819
    },
    points: [
      [0, 0],
      [144.8798313508311, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "rectangle",
    version: 1846,
    versionNonce: 1221575822,
    isDeleted: true,
    id: "MPdBT6gTOVGZBAgneRsVX",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 639.6315748215998,
    y: 328.57733740588463,
    strokeColor: "#c92a2a",
    backgroundColor: "#333300",
    width: 64.51880192272223,
    height: 49.91700598164563,
    seed: 1136109859,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 1585,
    versionNonce: 1080496978,
    isDeleted: true,
    id: "kWR-xz0eaSHpyotlmV_D7",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 738.5989482965304,
    y: 329.47060137231955,
    strokeColor: "#c92a2a",
    backgroundColor: "#333300",
    width: 64.51880192272223,
    height: 49.91700598164563,
    seed: 756043213,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["ZMbBDWRN8s-2erMfJfwPY"]
  },
  {
    type: "rectangle",
    version: 1978,
    versionNonce: 734266062,
    isDeleted: true,
    id: "-wJUS3WhfLEC6c7Tg6g78",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 639.7876310146899,
    y: 410.93657992978495,
    strokeColor: "#c92a2a",
    backgroundColor: "#333300",
    width: 64.51880192272223,
    height: 49.91700598164563,
    seed: 1060475939,
    groupIds: ["6EHYgj4dZa1mDbYO67UeW", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: ["zY80ErBY28YbIfLuW1hlY"]
  },
  {
    type: "text",
    version: 1037,
    versionNonce: 1686952210,
    isDeleted: true,
    id: "_1RprhH1f1t0p0t2WLlhy",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 317.03297727808945,
    y: 278.05651871966955,
    strokeColor: "#000000",
    backgroundColor: "#1ca9b0",
    width: 408.48114818568047,
    height: 7.620916943762697,
    seed: 1818573645,
    groupIds: ["sX-GCoHn7Af_0nVb_e1L1", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.0967335550101565,
    fontFamily: 1,
    text: "Diagram Of Google Cloud services used by the application (Authentication, Firestore and Cloud Storage) and the relation among them.",
    baseline: 5.620916943762697,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 931,
    versionNonce: 437680398,
    isDeleted: true,
    id: "VDmRPk_QR09O9laKuYwI9",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 500.0360577562699,
    y: 278.03745735560534,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 41.915043190694796,
    height: 7.620916943762697,
    seed: 1914852131,
    groupIds: ["sX-GCoHn7Af_0nVb_e1L1", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.096733555010155,
    fontFamily: 1,
    text: "Authentication",
    baseline: 5.620916943762697,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 898,
    versionNonce: 326362834,
    isDeleted: true,
    id: "cBzeNLU7pPvBNGZwK3QtW",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 546.6668230165837,
    y: 278.0154800888417,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 27.4353009975457,
    height: 7.620916943762697,
    seed: 1511020813,
    groupIds: ["sX-GCoHn7Af_0nVb_e1L1", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.096733555010145,
    fontFamily: 1,
    text: "Firestore",
    baseline: 5.620916943762697,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 883,
    versionNonce: 2067801934,
    isDeleted: true,
    id: "mU3ha-oXvU9eCX8P0P5FF",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 590.4575260297422,
    y: 278.0464480556562,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 43.439226579447414,
    height: 7.620916943762697,
    seed: 347145123,
    groupIds: ["sX-GCoHn7Af_0nVb_e1L1", "EjEEqeQbcyOKumz4fxbvv", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.096733555010164,
    fontFamily: 1,
    text: "Cloud Storage",
    baseline: 5.620916943762697,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1413,
    versionNonce: 1974680722,
    isDeleted: true,
    id: "2zZxtjRXabj_AKVRreFql",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 384.7453638560718,
    y: 104.32634943181824,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 272.8288265867048,
    height: 17.147063123466065,
    seed: 379233188,
    groupIds: ["MnyTabqxbSxckoU5HkS09", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 13.717650498772855,
    fontFamily: 1,
    text: "Full-stack app implementation description",
    baseline: 12.147063123466065,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3101,
    versionNonce: 1603931534,
    isDeleted: true,
    id: "R_q93zLY7-P_m3oRv8wOC",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 222.30507891071932,
    y: 132.7021980710731,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 597.0988425438079,
    height: 57.1568770782202,
    seed: 785136156,
    groupIds: ["LCTbaSmAGP8aw2JD8mOO2", "MnyTabqxbSxckoU5HkS09", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762713,
    fontFamily: 1,
    text:
      'This is the description of one of the main pieces of code I have ever implemented. It involved not just front end but also back end\nwhich I did for the same time in a professional environment for a production application. The backend technology was implemented using \nGoogle Cloud Platform (GCP) and due to ownership of the code I can\'t do any more than creating this diagram explaining the design of the system :(\n\nThis application was part of a bigger system which contained this as a "social collaboration" section. The best way to describe the app is as a Twitter-like\ntool where users could publish content in a stream of post. These posts could include images, links, tags, labels to other users...',
    baseline: 54.1568770782202,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2178,
    versionNonce: 151116370,
    isDeleted: true,
    id: "ozm9BKfMFYMk2zETJQPHU",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 629.677298029326,
    y: 132.70335000628262,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 140.9869634596097,
    height: 9.526146179703364,
    seed: 1088600868,
    groupIds: ["LCTbaSmAGP8aw2JD8mOO2", "MnyTabqxbSxckoU5HkS09", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762676,
    fontFamily: 1,
    text: "not just front end but also back end",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1303,
    versionNonce: 1683827662,
    isDeleted: true,
    id: "spuNXn_KzniBVTi5RtMvl",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 235.9778682645799,
    y: 151.90679776298435,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 85.35426977014214,
    height: 9.526146179703364,
    seed: 1783510022,
    groupIds: ["LCTbaSmAGP8aw2JD8mOO2", "MnyTabqxbSxckoU5HkS09", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762679,
    fontFamily: 1,
    text: "Google Cloud Platform",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1157,
    versionNonce: 2083962898,
    isDeleted: true,
    id: "1VRSKGgdX7op4-CG3rkw-",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 276.04620039854666,
    y: 180.31733195173297,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 223.161066392729,
    height: 9.263289548377426,
    seed: 906101229,
    groupIds: ["LCTbaSmAGP8aw2JD8mOO2", "MnyTabqxbSxckoU5HkS09", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.6209169437627,
    fontFamily: 1,
    text: "tool where users could publish content in a stream of post",
    baseline: 6.263289548377426,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 862,
    versionNonce: 396526094,
    isDeleted: true,
    id: "vH35YKUEmWhxQhcfYLAtY",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 776.3609105196358,
    y: 170.79493848971993,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 43.05818073225918,
    height: 9.526146179703364,
    seed: 1889502445,
    groupIds: ["LCTbaSmAGP8aw2JD8mOO2", "MnyTabqxbSxckoU5HkS09", "1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.620916943762675,
    fontFamily: 1,
    text: "Twitter-like",
    baseline: 6.526146179703364,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 1745,
    versionNonce: 189328850,
    isDeleted: true,
    id: "fQOG1lUPdvdjXapErhISk",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 37.52777127933135,
    y: 1219.6415486959083,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 967.2113794132033,
    height: 0,
    seed: 2048905389,
    groupIds: ["1scXQKZyMHLqY4ZkebLw3"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [967.2113794132033, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 1597,
    versionNonce: 1833491085,
    isDeleted: false,
    id: "6bSmQQqPXDqS5HjFK3tvB",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 15.76623292599717,
    y: 559.8260160578141,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 842.5379908609106,
    height: 0,
    seed: 88075282,
    groupIds: ["GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [842.5379908609106, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "text",
    version: 2673,
    versionNonce: 204579011,
    isDeleted: false,
    id: "7zvMUMTpxh6L1_GrtomoU",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 297.0985189952198,
    y: 1138.9587840219126,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 279.816231158283,
    height: 23.56696608806413,
    seed: 1611798030,
    groupIds: ["QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 18.697117280738404,
    fontFamily: 1,
    text: "CLOUD/LAMBDA FUNCTIONS",
    baseline: 16.56696608806413,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2340,
    versionNonce: 1103626477,
    isDeleted: false,
    id: "Q4DJ5-Acg8JGCbKy-v6km",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 299.85229425696957,
    y: 1212.5058723613238,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 64.06231626755462,
    height: 11.617518494116124,
    seed: 1917622738,
    groupIds: ["52eUJKJfFrXwtm7-ZnmSc", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292911,
    fontFamily: 1,
    text: "Authentication",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2141,
    versionNonce: 526815331,
    isDeleted: false,
    id: "nqlsTud0uKveqnPKigCPp",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 299.85229425696684,
    y: 1228.9546331272372,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 71.3647564638562,
    height: 41.49113747898622,
    seed: 432022606,
    groupIds: ["52eUJKJfFrXwtm7-ZnmSc", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637783,
    fontFamily: 1,
    text: "- createUserFirestore\n\n- deleteUserFirestore\n\n- disableNewUser",
    baseline: 39.49113747898622,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2518,
    versionNonce: 1548966733,
    isDeleted: false,
    id: "d7zG5DiAGGhNEixDSQ4JF",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 299.97970887016675,
    y: 1289.0099544719715,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 41.49113747898622,
    height: 11.617518494116124,
    seed: 2096992146,
    groupIds: ["jMDrRzBa2wl2SWQ8ZUpbs", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292911,
    fontFamily: 1,
    text: "Firestore",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2471,
    versionNonce: 1234996227,
    isDeleted: false,
    id: "WIbQ69ZszsGCYmfCksmul",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 299.9138499217903,
    y: 1305.477066779047,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 127.12884523561353,
    height: 74.68404746217519,
    seed: 118647438,
    groupIds: ["jMDrRzBa2wl2SWQ8ZUpbs", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637784,
    fontFamily: 1,
    text:
      "- deletePostImagesAndComments\n\n- generate/deleteCommentNotifications\n\n- generate/deletePostNotifications\n\n- generateCommentLikeNotification\n\n- generatePostLikeNotification",
    baseline: 72.68404746217519,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2709,
    versionNonce: 356805037,
    isDeleted: false,
    id: "qwLdxpeZSp4eHx0P0BJa9",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 496.762336897758,
    y: 1212.9529751358677,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 66.38581996637787,
    height: 11.617518494116124,
    seed: 2039074130,
    groupIds: ["XCM_7YwIq4eVoSMPxsHJ9", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.29401479529291,
    fontFamily: 1,
    text: "Cloud Storage",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2533,
    versionNonce: 517084067,
    isDeleted: false,
    id: "u8N0I_0PjQ5XUExB8zfyP",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 496.7606530041878,
    y: 1229.4034197953656,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 76.34369296133447,
    height: 24.894682487391695,
    seed: 381806798,
    groupIds: ["XCM_7YwIq4eVoSMPxsHJ9", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637786,
    fontFamily: 1,
    text: "- updateSuppliersConfig\n\n- updateKeywordsIds",
    baseline: 22.894682487391695,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2801,
    versionNonce: 2110041101,
    isDeleted: false,
    id: "cw3F2Jjf-9GL5bpH3dN06",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 496.75728521705264,
    y: 1270.9849991187507,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 28.877831685374343,
    height: 11.617518494116124,
    seed: 491279122,
    groupIds: ["0yWA67KJ0gYcdZ5sI-Pc7", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292897,
    fontFamily: 1,
    text: "HTTP",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2683,
    versionNonce: 792045379,
    isDeleted: false,
    id: "sonRA8JOkFm0uiWE8EQti",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 496.8381121082498,
    y: 1287.4337598846785,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 65.05810356705035,
    height: 58.08759247058066,
    seed: 2020056846,
    groupIds: ["0yWA67KJ0gYcdZ5sI-Pc7", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.63858199663779,
    fontFamily: 1,
    text: "- updateUserEntries\n\n- getAllUsers\n\n- getAllPosts\n\n- addUserDoc",
    baseline: 56.08759247058066,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3034,
    versionNonce: 1171104365,
    isDeleted: false,
    id: "42T9MNIjuwc51RPGdHcwU",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 496.6983489422281,
    y: 1364.6122879063996,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 42.81885387831367,
    height: 11.617518494116124,
    seed: 1521492178,
    groupIds: ["jVrBgiurczlRCJcNJ57qZ", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.29401479529289,
    fontFamily: 1,
    text: "Scheduled",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2928,
    versionNonce: 19252963,
    isDeleted: false,
    id: "duS0hwPGsgeS_pjP9wCqc",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 496.77917583342355,
    y: 1381.087990969381,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 77.3394802608302,
    height: 8.298227495797233,
    seed: 8162638,
    groupIds: ["jVrBgiurczlRCJcNJ57qZ", "_Jff0Fw1oo3o4nNQtzxXS", "QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637788,
    fontFamily: 1,
    text: "- deleteOldNotifications",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1700,
    versionNonce: 1646841037,
    isDeleted: false,
    id: "7OfkpBOIQpya-bGWn2Goy",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 280.5306577857155,
    y: 1178.1711813743696,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 313.0091411414711,
    height: 13.277163993275572,
    seed: 1029191314,
    groupIds: ["QYG4CbJ6Rzxj4ffj6yeBk", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.310865597310202,
    fontFamily: 1,
    text:
      "These functions are basically backend code executed when some event is triggered. Here we have the list of functions\npowering the application classified by event-type trigger:",
    baseline: 11.277163993275572,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2417,
    versionNonce: 1261499011,
    isDeleted: false,
    id: "F7d3XMd9La9v33Taltw53",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 319.2187973933061,
    y: 602.2879106366622,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 235.66966088064174,
    height: 23.56696608806413,
    seed: 207205262,
    groupIds: ["_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 18.697117280738407,
    fontFamily: 1,
    text: "DATABASE STRUCTURE",
    baseline: 16.56696608806413,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1494,
    versionNonce: 1919920941,
    isDeleted: false,
    id: "FjHRC_20E5j__radQm8Gi",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 239.1987783150255,
    y: 641.5198941647585,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 395.65948699961245,
    height: 24.894682487391695,
    seed: 1173853266,
    groupIds: ["20RbycihwAYka7bi7i6_3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637798,
    fontFamily: 1,
    text:
      "GCP offers a non-relational database solution with Firebase, which is based in collections/sub-collections of documents.\nThe main two collections for this app were Users and Posts:\n",
    baseline: 22.894682487391695,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1649,
    versionNonce: 1846913571,
    isDeleted: false,
    id: "AXciZ5SX_nuRni0LA6vWd",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 413.1133961098417,
    y: 641.5315898706083,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 27.88204438587871,
    height: 8.298227495797233,
    seed: 1714950606,
    groupIds: ["20RbycihwAYka7bi7i6_3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637784,
    fontFamily: 1,
    text: "Firebase",
    baseline: 6.298227495797233,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1652,
    versionNonce: 1728822669,
    isDeleted: false,
    id: "XsOeJE2yY4DdTxtdJkh2S",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 384.5526672075134,
    y: 649.7334744941837,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 18.588029590585805,
    height: 8.298227495797233,
    seed: 1181039122,
    groupIds: ["20RbycihwAYka7bi7i6_3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637778,
    fontFamily: 1,
    text: "Users",
    baseline: 6.298227495797233,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1465,
    versionNonce: 784494019,
    isDeleted: false,
    id: "WykqsmPhGE6FlM9wueWAd",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 421.0074796320175,
    y: 649.7514013715208,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 18.588029590585805,
    height: 8.298227495797233,
    seed: 691054606,
    groupIds: ["20RbycihwAYka7bi7i6_3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637778,
    fontFamily: 1,
    text: "Posts",
    baseline: 6.298227495797233,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 4102,
    versionNonce: 1731625965,
    isDeleted: false,
    id: "nnTS1vX3EhsM7Jd0xkXq2",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 49.670565881577254,
    y: 780.5382810670664,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 123.74450965282833,
    height: 146.1186943486492,
    seed: 1033381842,
    groupIds: [
      "BP-6MLgPReg7DETOEIT0o",
      "--RwwzBtFhNGv19jaz2LK",
      "7qwjlPgPOYrLbOTCElf8A",
      "p7fPT9KPDkcVSz-tQLpI3",
      "O4D2MqLSl_mZCdMDXg7c3",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4125,
    versionNonce: 810925411,
    isDeleted: false,
    id: "RdT65mGKbJ3trpusv2yip",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 39.04554881646001,
    y: 770.0406878405165,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 129.67269189925605,
    height: 151.32507871580586,
    seed: 624719438,
    groupIds: [
      "BP-6MLgPReg7DETOEIT0o",
      "--RwwzBtFhNGv19jaz2LK",
      "7qwjlPgPOYrLbOTCElf8A",
      "p7fPT9KPDkcVSz-tQLpI3",
      "O4D2MqLSl_mZCdMDXg7c3",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ"]
  },
  {
    type: "rectangle",
    version: 3929,
    versionNonce: 1996062285,
    isDeleted: false,
    id: "P2oj6dv_Jue9UF4kGt-qF",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 28.55097093420588,
    y: 759.3674252667001,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 135.3361101916767,
    height: 155.63174880847654,
    seed: 866606482,
    groupIds: [
      "BP-6MLgPReg7DETOEIT0o",
      "--RwwzBtFhNGv19jaz2LK",
      "7qwjlPgPOYrLbOTCElf8A",
      "p7fPT9KPDkcVSz-tQLpI3",
      "O4D2MqLSl_mZCdMDXg7c3",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "text",
    version: 2594,
    versionNonce: 773724419,
    isDeleted: false,
    id: "bWy5V9E2uhbt4bOl7sOR-",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 88.50858251161547,
    y: 768.2166965972896,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 19.915745989913358,
    height: 11.617518494116124,
    seed: 1127513230,
    groupIds: ["7qwjlPgPOYrLbOTCElf8A", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292904,
    fontFamily: 1,
    text: "User",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2889,
    versionNonce: 1563307181,
    isDeleted: false,
    id: "K1_wwD1Qe881zkd5kk9WM",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 38.61645460331005,
    y: 786.0586898050569,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 120.15833413914405,
    height: 116.17518494116132,
    seed: 365550418,
    groupIds: ["7qwjlPgPOYrLbOTCElf8A", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292904,
    fontFamily: 1,
    text:
      "+ name: String\n+ email: String\n+ photoUrl: URL\n+ supplierInfo\n  - supplierName: String\n  - primaryColor: String\n  - secondaryColor: String\n  - supplierLogo: URL\n    ...\n+ cookieConsent: Boolean",
    baseline: 113.17518494116132,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 4324,
    versionNonce: 1973026979,
    isDeleted: false,
    id: "qKRcvo8v9NY2Sl_wwLFxn",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 263.58592011381694,
    y: 864.0465448497793,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 128.81908574364252,
    height: 74.2758900294733,
    seed: 1758575310,
    groupIds: ["QvEO5QfReMR83EfcP6b6X", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4427,
    versionNonce: 1232998157,
    isDeleted: false,
    id: "g4-dnpH33rT5wUug6RYTO",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 256.9722103514315,
    y: 857.4892305665262,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 132.44434333014584,
    height: 77.17892127811831,
    seed: 307667218,
    groupIds: ["QvEO5QfReMR83EfcP6b6X", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ"]
  },
  {
    type: "rectangle",
    version: 4501,
    versionNonce: 544732227,
    isDeleted: false,
    id: "uykcy42B1cTRLIylh1h02",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 250.1763251595484,
    y: 850.7752628663327,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 136.47361242030655,
    height: 80.74993087129363,
    seed: 1554854158,
    groupIds: ["QvEO5QfReMR83EfcP6b6X", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "text",
    version: 2956,
    versionNonce: 979543405,
    isDeleted: false,
    id: "mVP0zO3do7xBOScyCw-CP",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 295.09864585137143,
    y: 859.659420757955,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 52.44479777343851,
    height: 11.617518494116124,
    seed: 1959046866,
    groupIds: ["QvEO5QfReMR83EfcP6b6X", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292886,
    fontFamily: 1,
    text: "Notification",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3323,
    versionNonce: 1534003117,
    isDeleted: false,
    id: "sysB4KRJSjqZj8onsbs5S",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 254.76024941442478,
    y: 878.0661311410864,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 72.02861466351992,
    height: 46.4700739764645,
    seed: 708829006,
    groupIds: ["QvEO5QfReMR83EfcP6b6X", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["uiDUNChZfKRkiIwaopj7a"],
    fontSize: 9.29401479529289,
    fontFamily: 1,
    text: "+ author: User\n+ seen: Boolean\n+ count: Number\n+ parentId: uid",
    baseline: 43.4700739764645,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 2353,
    versionNonce: 537132931,
    isDeleted: false,
    id: "fp8wuX1qC6ulq9xIVrZ-P",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 211.37215138571656,
    y: 782.0923907449242,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 0,
    height: 113.43098561326613,
    seed: 27985042,
    groupIds: ["fCSr49FiUkXacCbyqbXp5", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [0, 113.43098561326613]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 4477,
    versionNonce: 1753567843,
    isDeleted: false,
    id: "6bgRoD2Yf1r0mBF43HL-4",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 211.51663961330428,
    y: 782.2633744370021,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 38.47465368131587,
    height: 0.020699922438230024,
    seed: 98747790,
    groupIds: ["fCSr49FiUkXacCbyqbXp5", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "AeDI6txfhinBww20mvs-p",
      focus: 1.2206165204614459,
      gap: 5.430508403313752
    },
    points: [
      [0, 0],
      [38.47465368131587, -0.020699922438230024]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "arrow",
    version: 4888,
    versionNonce: 1167265283,
    isDeleted: false,
    id: "uiDUNChZfKRkiIwaopj7a",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 211.6153816849046,
    y: 895.3412030701315,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 38.00909438487647,
    height: 0,
    seed: 1388356178,
    groupIds: ["fCSr49FiUkXacCbyqbXp5", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "sysB4KRJSjqZj8onsbs5S",
      focus: 0.25650766393037017,
      gap: 5.135773344643724
    },
    points: [
      [0, 0],
      [38.00909438487647, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 2486,
    versionNonce: 360423565,
    isDeleted: false,
    id: "mUYb7elmTXBmNtSXuERUf",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 164.41241769017086,
    y: 843.4543909414583,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 46.80913436555057,
    height: 0,
    seed: 818865102,
    groupIds: ["fCSr49FiUkXacCbyqbXp5", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [46.80913436555057, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "rectangle",
    version: 4149,
    versionNonce: 1240873667,
    isDeleted: false,
    id: "vYshmcvclmR9MRDT5ekac",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 264.21544893108614,
    y: 769.6494359647916,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 128.81908574364252,
    height: 38.06201934625181,
    seed: 853313554,
    groupIds: ["No0CQhtKNHeSjZgQTZNJL", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4168,
    versionNonce: 598869741,
    isDeleted: false,
    id: "VPwPuEm4OU1Ac7Iuv4aB1",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 257.4857813361854,
    y: 762.825755343775,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 132.44434333014584,
    height: 41.64931612033139,
    seed: 1562196494,
    groupIds: ["No0CQhtKNHeSjZgQTZNJL", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ", "6bgRoD2Yf1r0mBF43HL-4"]
  },
  {
    type: "rectangle",
    version: 4228,
    versionNonce: 763882083,
    isDeleted: false,
    id: "cRVPG-8mRUNCZdkiXTiQO",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 250.74948014872274,
    y: 756.1655776712319,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 136.47361242030655,
    height: 44.9356378816199,
    seed: 2046146002,
    groupIds: ["No0CQhtKNHeSjZgQTZNJL", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["6bgRoD2Yf1r0mBF43HL-4"]
  },
  {
    type: "text",
    version: 2968,
    versionNonce: 1057792333,
    isDeleted: false,
    id: "ch-EiPK32JPdJ7X35aZGm",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 287.4336292779773,
    y: 765.3088202811501,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 63.39845806789101,
    height: 11.617518494116124,
    seed: 298240078,
    groupIds: ["No0CQhtKNHeSjZgQTZNJL", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292934,
    fontFamily: 1,
    text: "Watchlist item",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3165,
    versionNonce: 2122491395,
    isDeleted: false,
    id: "iG5rDq7oDcT0TnXYsoLPG",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 255.4524158184663,
    y: 783.5266783401499,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 91.28050245376961,
    height: 11.617518494116124,
    seed: 1763912594,
    groupIds: ["No0CQhtKNHeSjZgQTZNJL", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["6bgRoD2Yf1r0mBF43HL-4"],
    fontSize: 9.29401479529291,
    fontFamily: 1,
    text: "+ dateAdded: Date",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 4150,
    versionNonce: 484765613,
    isDeleted: false,
    id: "ZWNqM3ZG7SvzUr2AaJk1C",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 264.1848348105546,
    y: 769.6494359647916,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 128.81908574364252,
    height: 38.06201934625181,
    seed: 245665422,
    groupIds: [
      "6GFH5xLzHeEw24HloR6qT",
      "No0CQhtKNHeSjZgQTZNJL",
      "p7fPT9KPDkcVSz-tQLpI3",
      "O4D2MqLSl_mZCdMDXg7c3",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4175,
    versionNonce: 1139076515,
    isDeleted: false,
    id: "VnOjNWgi2MtXlLEenfPHR",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 257.62984778576623,
    y: 762.825755343775,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 132.44434333014584,
    height: 41.64931612033139,
    seed: 110881106,
    groupIds: [
      "6GFH5xLzHeEw24HloR6qT",
      "No0CQhtKNHeSjZgQTZNJL",
      "p7fPT9KPDkcVSz-tQLpI3",
      "O4D2MqLSl_mZCdMDXg7c3",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ", "6bgRoD2Yf1r0mBF43HL-4"]
  },
  {
    type: "rectangle",
    version: 4280,
    versionNonce: 191132173,
    isDeleted: false,
    id: "3FtCWDcMoW8Azd3ZFr9Io",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 250.8629324777632,
    y: 756.1655776712319,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 136.47361242030655,
    height: 44.9356378816199,
    seed: 812616910,
    groupIds: [
      "6GFH5xLzHeEw24HloR6qT",
      "No0CQhtKNHeSjZgQTZNJL",
      "p7fPT9KPDkcVSz-tQLpI3",
      "O4D2MqLSl_mZCdMDXg7c3",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["6bgRoD2Yf1r0mBF43HL-4"]
  },
  {
    type: "text",
    version: 2967,
    versionNonce: 551371075,
    isDeleted: false,
    id: "jEPFc_pOf2OFi_WPHf2Cg",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 287.4030151574418,
    y: 765.3088202811501,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 63.39845806789101,
    height: 11.617518494116124,
    seed: 2042031890,
    groupIds: ["No0CQhtKNHeSjZgQTZNJL", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292934,
    fontFamily: 1,
    text: "Watchlist item",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3209,
    versionNonce: 1257879885,
    isDeleted: false,
    id: "AeDI6txfhinBww20mvs-p",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 255.42180169793392,
    y: 783.5266783401499,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 91.28050245376961,
    height: 11.617518494116124,
    seed: 1421918990,
    groupIds: ["No0CQhtKNHeSjZgQTZNJL", "p7fPT9KPDkcVSz-tQLpI3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["6bgRoD2Yf1r0mBF43HL-4"],
    fontSize: 9.29401479529291,
    fontFamily: 1,
    text: "+ dateAdded: Date",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2810,
    versionNonce: 1930367693,
    isDeleted: false,
    id: "2_srSL8UrqWs8nVqoFPCa",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 3.1711008596212196,
    y: 952.6466089770668,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 415.24330388969315,
    height: 6.638581996637786,
    seed: 1726692562,
    groupIds: ["_bw1flmRsQ1ndzCsAPO-3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.310865597310216,
    fontFamily: 1,
    text:
      "Each document in Users collection has two sub-collections associated which could contain 0 or more documents. Those are Watchlist Items and Notifications.",
    baseline: 4.638581996637786,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1428,
    versionNonce: 1463422083,
    isDeleted: false,
    id: "KO-yNt9gPIyEMtpcDO2KF",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 328.7761334272227,
    y: 952.6368879865472,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 41.15920837915427,
    height: 6.638581996637786,
    seed: 1041314126,
    groupIds: ["_bw1flmRsQ1ndzCsAPO-3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.31086559731022,
    fontFamily: 1,
    text: "Watchlist Items",
    baseline: 4.638581996637786,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1499,
    versionNonce: 1520251181,
    isDeleted: false,
    id: "yX9XFTijtfBgTlUT5bj0-",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 384.3220554842494,
    y: 952.5157406299606,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 32.86098088335706,
    height: 6.638581996637786,
    seed: 1271911058,
    groupIds: ["_bw1flmRsQ1ndzCsAPO-3", "O4D2MqLSl_mZCdMDXg7c3", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.310865597310218,
    fontFamily: 1,
    text: "Notifications",
    baseline: 4.638581996637786,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 5283,
    versionNonce: 233538595,
    isDeleted: false,
    id: "qz6jCxD3TVKUAgoKBi8Dd",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 522.6264154439999,
    y: 729.8537955315497,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 118.07513469573885,
    height: 144.7572355287381,
    seed: 2008668046,
    groupIds: [
      "8GIjUdpkYWjoa5r6xBCyC",
      "J7il0a2G7SM8tjB_tk5f9",
      "r56aXJoJ463ZmnY3xv69v",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 5159,
    versionNonce: 999850893,
    isDeleted: false,
    id: "5_2sfLpXjqDJA74QxdRrI",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 512.0812317728722,
    y: 719.3562023050115,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 126.64189396622074,
    height: 153.3804027187365,
    seed: 1528541266,
    groupIds: [
      "8GIjUdpkYWjoa5r6xBCyC",
      "J7il0a2G7SM8tjB_tk5f9",
      "r56aXJoJ463ZmnY3xv69v",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ"]
  },
  {
    type: "rectangle",
    version: 5018,
    versionNonce: 1254950851,
    isDeleted: false,
    id: "EAIC5LYX8d5kbvVcuiCmp",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 501.5593018461209,
    y: 708.6719186477985,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 135.3361101916767,
    height: 161.94346461193942,
    seed: 972273102,
    groupIds: [
      "8GIjUdpkYWjoa5r6xBCyC",
      "J7il0a2G7SM8tjB_tk5f9",
      "r56aXJoJ463ZmnY3xv69v",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["PA0FJN8GIghMOFywKQm4-"]
  },
  {
    type: "text",
    version: 2753,
    versionNonce: 1513785837,
    isDeleted: false,
    id: "2nXi4zjGc_v658FbNaJEt",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 563.3599657293098,
    y: 714.0889493085704,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 21.243462389240896,
    height: 11.617518494116124,
    seed: 1487263250,
    groupIds: [
      "15VOkmOZ3eFid255OqJD4",
      "r56aXJoJ463ZmnY3xv69v",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.29401479529289,
    fontFamily: 1,
    text: "Post",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3115,
    versionNonce: 552307213,
    isDeleted: false,
    id: "XECVvAfYjvv0BleLWDaoP",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 507.13257398803034,
    y: 733.5588253753914,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 115.84325584132944,
    height: 127.7927034352776,
    seed: 1305988110,
    groupIds: [
      "15VOkmOZ3eFid255OqJD4",
      "r56aXJoJ463ZmnY3xv69v",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["iK6ixsKxey2ZLTqkL5UwC", "PA0FJN8GIghMOFywKQm4-"],
    fontSize: 9.294014795292904,
    fontFamily: 1,
    text:
      "+ author: User\n+ date: Date\n+ commentsCount: Number\n+ images: URL[ ]\n+ keywords:\n  - id: uid\n  - label: String\n+ likes: String[ ]\n+ links: String[ ]\n+ location: String\n+ text: String",
    baseline: 124.7927034352776,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2372,
    versionNonce: 1741304579,
    isDeleted: false,
    id: "lZGeY7GB5CDNiN96YhU4w",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 819.1706124584693,
    y: 785.4844620791189,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 9.957872994956679,
    height: 14.936809492435016,
    seed: 1969570770,
    groupIds: ["u118Ke7C_WcqhXxStTOtt", "HZFERQTIa_l-M410FF2uq", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 11.949447593948028,
    fontFamily: 1,
    text: "...",
    baseline: 10.936809492435016,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2563,
    versionNonce: 2003350189,
    isDeleted: false,
    id: "z0XxLumZUEEuKpDkx4wzb",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 547.5634599048676,
    y: 684.2415452989753,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 47.13393217612826,
    height: 14.936809492435016,
    seed: 1902058062,
    groupIds: ["u118Ke7C_WcqhXxStTOtt", "HZFERQTIa_l-M410FF2uq", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 11.94944759394802,
    fontFamily: 1,
    text: "FIRM #1",
    baseline: 10.936809492435016,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2898,
    versionNonce: 380820131,
    isDeleted: false,
    id: "SuNJvyBby7eMQ5abR0wSX",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 703.610784473969,
    y: 686.1501376230001,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 54.104443272597884,
    height: 14.936809492435016,
    seed: 728824210,
    groupIds: ["u118Ke7C_WcqhXxStTOtt", "HZFERQTIa_l-M410FF2uq", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 11.949447593948006,
    fontFamily: 1,
    text: "FIRM #2",
    baseline: 10.936809492435016,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 4625,
    versionNonce: 108516621,
    isDeleted: false,
    id: "Of9gyMnQIRA5-p_8Wj7lN",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 513.5010221363021,
    y: 928.7600687976893,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 128.81908574364252,
    height: 74.2758900294733,
    seed: 996319374,
    groupIds: [
      "a-VW4B1DMmqh9a_fTpZ4Z",
      "ZmmJyy7PWsPBrVLGBjS7I",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4750,
    versionNonce: 493194819,
    isDeleted: false,
    id: "7ZhKoFOcGPkv0rrSaI3t-",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 506.78254640432976,
    y: 922.2523303220755,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 132.44434333014584,
    height: 77.17892127811831,
    seed: 436205394,
    groupIds: [
      "a-VW4B1DMmqh9a_fTpZ4Z",
      "ZmmJyy7PWsPBrVLGBjS7I",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ", "PA0FJN8GIghMOFywKQm4-"]
  },
  {
    type: "rectangle",
    version: 4889,
    versionNonce: 3386221,
    isDeleted: false,
    id: "zdyS6Pi2lPrIX8yrw4QkZ",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 499.94074410591793,
    y: 915.3039368476784,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 136.47361242030655,
    height: 80.74993087129363,
    seed: 2140888782,
    groupIds: [
      "a-VW4B1DMmqh9a_fTpZ4Z",
      "ZmmJyy7PWsPBrVLGBjS7I",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["PA0FJN8GIghMOFywKQm4-"]
  },
  {
    type: "text",
    version: 3238,
    versionNonce: 1550368877,
    isDeleted: false,
    id: "9EjtYn--tNkquVMQJ94QA",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 549.4860084287814,
    y: 924.3405297547107,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 38.83570468033106,
    height: 11.617518494116124,
    seed: 1634286866,
    groupIds: [
      "ohdwunEgXRh1kgRTTwb-H",
      "ZmmJyy7PWsPBrVLGBjS7I",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["PA0FJN8GIghMOFywKQm4-"],
    fontSize: 9.294014795292892,
    fontFamily: 1,
    text: "Comment",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3494,
    versionNonce: 500373891,
    isDeleted: false,
    id: "SpkZiU3GN_L09mdX70Q6u",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 505.14796407481015,
    y: 942.8536276698347,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 77.3394802608302,
    height: 46.4700739764645,
    seed: 849499406,
    groupIds: [
      "ohdwunEgXRh1kgRTTwb-H",
      "ZmmJyy7PWsPBrVLGBjS7I",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["uiDUNChZfKRkiIwaopj7a"],
    fontSize: 9.294014795292902,
    fontFamily: 1,
    text: "+ author: User\n+ date: Date\n+ likes: String[ ]\n+ text: String",
    baseline: 43.4700739764645,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "arrow",
    version: 6590,
    versionNonce: 1559472451,
    isDeleted: false,
    id: "PA0FJN8GIghMOFywKQm4-",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 571.5154291555215,
    y: 873.3004029063767,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 0.7700063251754744,
    height: 41.263727611975874,
    seed: 2133052114,
    groupIds: ["u118Ke7C_WcqhXxStTOtt", "HZFERQTIa_l-M410FF2uq", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: {
      elementId: "XECVvAfYjvv0BleLWDaoP",
      focus: -0.13324337792717614,
      gap: 11.948874095707652
    },
    endBinding: {
      elementId: "9EjtYn--tNkquVMQJ94QA",
      focus: 0.07941789694672391,
      gap: 9.776399236358031
    },
    points: [
      [0, 0],
      [-0.7700063251754744, 41.263727611975874]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "rectangle",
    version: 5539,
    versionNonce: 400224547,
    isDeleted: false,
    id: "UtAbWCsLHL7_kRQvafXQh",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 682.1589955613345,
    y: 730.3324785971023,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 118.07513469573885,
    height: 144.7572355287381,
    seed: 1307607886,
    groupIds: [
      "PeFcRpeBbYSpYhNXEy-Dg",
      "RLnWNVVrdx_TCBFjzj-su",
      "DkL_8Ym02ZM5P1M09mAJT",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 5415,
    versionNonce: 476210829,
    isDeleted: false,
    id: "Lle4lAgbpph2XQpEfNvFv",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 671.6138118902056,
    y: 719.8348853705681,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 126.64189396622074,
    height: 153.3804027187365,
    seed: 700883090,
    groupIds: [
      "PeFcRpeBbYSpYhNXEy-Dg",
      "RLnWNVVrdx_TCBFjzj-su",
      "DkL_8Ym02ZM5P1M09mAJT",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ"]
  },
  {
    type: "rectangle",
    version: 5271,
    versionNonce: 507958467,
    isDeleted: false,
    id: "oKQqmcphCv4z28JfOEats",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 661.0918819634585,
    y: 709.1506017133561,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 135.3361101916767,
    height: 161.94346461193942,
    seed: 870246798,
    groupIds: [
      "PeFcRpeBbYSpYhNXEy-Dg",
      "RLnWNVVrdx_TCBFjzj-su",
      "DkL_8Ym02ZM5P1M09mAJT",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["iK6ixsKxey2ZLTqkL5UwC"]
  },
  {
    type: "text",
    version: 3012,
    versionNonce: 1842351341,
    isDeleted: false,
    id: "we1n8lftTl1f5qMSXoZ9Z",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 722.8357836655159,
    y: 714.4379725694997,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 21.243462389240896,
    height: 11.617518494116124,
    seed: 755547730,
    groupIds: [
      "m-xHXrf932VuicSH1LD18",
      "DkL_8Ym02ZM5P1M09mAJT",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.29401479529289,
    fontFamily: 1,
    text: "Post",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3372,
    versionNonce: 1940925133,
    isDeleted: false,
    id: "n0iXuaUzV_DQ8wZ1RqZeH",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 666.6083919242353,
    y: 733.907848636312,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 115.84325584132944,
    height: 127.7927034352776,
    seed: 329680846,
    groupIds: [
      "m-xHXrf932VuicSH1LD18",
      "DkL_8Ym02ZM5P1M09mAJT",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["iK6ixsKxey2ZLTqkL5UwC"],
    fontSize: 9.294014795292904,
    fontFamily: 1,
    text:
      "+ author: User\n+ date: Date\n+ commentsCount: Number\n+ images: URL[ ]\n+ keywords:\n  - id: uid\n  - label: String\n+ likes: String[ ]\n+ links: String[ ]\n+ location: String\n+ text: String",
    baseline: 124.7927034352776,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 4752,
    versionNonce: 385138691,
    isDeleted: false,
    id: "uafdCc4u7XivuJEGbOxQU",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 673.0336022536424,
    y: 928.6642332899218,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 128.81908574364252,
    height: 74.2758900294733,
    seed: 1170285586,
    groupIds: [
      "5i9SsIAqux62Sw2rDA265",
      "1PdQhgXfCJ4KYRbhkiRd2",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 4878,
    versionNonce: 263812525,
    isDeleted: false,
    id: "o3kHJkRsvSj0W_iNDgWMc",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 666.3151265216659,
    y: 922.1564948143116,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 132.44434333014584,
    height: 77.17892127811831,
    seed: 1298161166,
    groupIds: [
      "5i9SsIAqux62Sw2rDA265",
      "1PdQhgXfCJ4KYRbhkiRd2",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["W9VXMGS9LmmpyAnHHH8wJ", "iK6ixsKxey2ZLTqkL5UwC"]
  },
  {
    type: "rectangle",
    version: 5023,
    versionNonce: 2063845283,
    isDeleted: false,
    id: "J4ucWPSToadmlFRgguNxo",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 659.4733242232578,
    y: 915.2081013399061,
    strokeColor: "#1ca9b0",
    backgroundColor: "#fff",
    width: 136.47361242030655,
    height: 80.74993087129363,
    seed: 2112278994,
    groupIds: [
      "5i9SsIAqux62Sw2rDA265",
      "1PdQhgXfCJ4KYRbhkiRd2",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["iK6ixsKxey2ZLTqkL5UwC"]
  },
  {
    type: "text",
    version: 3366,
    versionNonce: 1465600301,
    isDeleted: false,
    id: "VR7ia8UqIjLUzmHubMIhy",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 709.0185885461183,
    y: 924.2446942469438,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 38.83570468033106,
    height: 11.617518494116124,
    seed: 1443195982,
    groupIds: [
      "nznKHaHzLPbbwDeRt_mjB",
      "1PdQhgXfCJ4KYRbhkiRd2",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["iK6ixsKxey2ZLTqkL5UwC"],
    fontSize: 9.294014795292892,
    fontFamily: 1,
    text: "Comment",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3622,
    versionNonce: 393195117,
    isDeleted: false,
    id: "tGpG4C3uUv1dSYuuyr1wX",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 664.6805441921415,
    y: 942.757792162067,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 77.3394802608302,
    height: 46.4700739764645,
    seed: 143706002,
    groupIds: [
      "nznKHaHzLPbbwDeRt_mjB",
      "1PdQhgXfCJ4KYRbhkiRd2",
      "u118Ke7C_WcqhXxStTOtt",
      "HZFERQTIa_l-M410FF2uq",
      "_VbsAjXC0p3USNMnoDBJV",
      "GIykbjzF-JcNMdlm48lKk"
    ],
    strokeSharpness: "sharp",
    boundElementIds: ["uiDUNChZfKRkiIwaopj7a"],
    fontSize: 9.294014795292902,
    fontFamily: 1,
    text: "+ author: User\n+ date: Date\n+ likes: String[ ]\n+ text: String",
    baseline: 43.4700739764645,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "arrow",
    version: 6935,
    versionNonce: 2127983747,
    isDeleted: false,
    id: "iK6ixsKxey2ZLTqkL5UwC",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 730.6630061102678,
    y: 873.1165866128817,
    strokeColor: "#1ca9b0",
    backgroundColor: "transparent",
    width: 0,
    height: 41.16032230744514,
    seed: 460239502,
    groupIds: ["u118Ke7C_WcqhXxStTOtt", "HZFERQTIa_l-M410FF2uq", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: {
      elementId: "n0iXuaUzV_DQ8wZ1RqZeH",
      focus: -0.1058842177876653,
      gap: 11.416034541292106
    },
    endBinding: {
      elementId: "VR7ia8UqIjLUzmHubMIhy",
      focus: 0.1146658850308749,
      gap: 9.967785326616934
    },
    points: [
      [0, 0],
      [0, 41.16032230744514]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "text",
    version: 2419,
    versionNonce: 1269389517,
    isDeleted: false,
    id: "CEandg46ih8SsrvtFb7Ld",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 818.5955994118901,
    y: 951.6057075834417,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 9.957872994956679,
    height: 14.936809492435016,
    seed: 502662482,
    groupIds: ["u118Ke7C_WcqhXxStTOtt", "HZFERQTIa_l-M410FF2uq", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 11.949447593948028,
    fontFamily: 1,
    text: "...",
    baseline: 10.936809492435016,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3293,
    versionNonce: 550446723,
    isDeleted: false,
    id: "SuCWwYoDQnW_FrBqA6odh",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 458.3840942528351,
    y: 1017.926564534526,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 412.25594199120656,
    height: 13.277163993275572,
    seed: 1750413518,
    groupIds: ["TXvvmQk3J71RbfIptPP6Q", "HZFERQTIa_l-M410FF2uq", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.310865597310221,
    fontFamily: 1,
    text:
      "The application is used by different clients so we need independent post collections so users from each company would see only posts from their colleagues.\nEach Post has a associated sub-collection Comments.",
    baseline: 11.277163993275572,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1454,
    versionNonce: 1946072877,
    isDeleted: false,
    id: "u8Pr6Z7MkNrfw0G0Xputt",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 708.6166421695377,
    y: 1024.570641349326,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 24.894682487391695,
    height: 6.638581996637786,
    seed: 1466796818,
    groupIds: ["TXvvmQk3J71RbfIptPP6Q", "HZFERQTIa_l-M410FF2uq", "_VbsAjXC0p3USNMnoDBJV", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.310865597310224,
    fontFamily: 1,
    text: "Comments",
    baseline: 4.638581996637786,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1838,
    versionNonce: 1506631203,
    isDeleted: false,
    id: "lJ8m9eCyPeGQH7c34Gzt8",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 358.6961439534999,
    y: 229.93407207766143,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 156.92223432048306,
    height: 23.371396600923035,
    seed: 1213327118,
    groupIds: ["yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 18.697117280738382,
    fontFamily: 1,
    text: "ARCHITECTURE",
    baseline: 16.371396600923035,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 2118,
    versionNonce: 2061060493,
    isDeleted: false,
    id: "9fSzQEyygff53f0Dg7Tts",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 240.21968257159762,
    y: 363.71953913506854,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 244.45195164702685,
    height: 82.30063484224624,
    seed: 191781074,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["fIR0c5py93ZEN3l8mgap-", "vpsPPt2cjRVHtA1fPYzkT"]
  },
  {
    type: "text",
    version: 1828,
    versionNonce: 828613059,
    isDeleted: false,
    id: "eIbNO2ACvREZC5mYNrHD1",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 266.80559341787006,
    y: 387.7719268345331,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 41.49113747898622,
    height: 11.617518494116124,
    seed: 1809700174,
    groupIds: ["ObK7UHxfv8_xKyhqeF3Kz", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.294014795292911,
    fontFamily: 1,
    text: "Firestore",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1929,
    versionNonce: 684956557,
    isDeleted: false,
    id: "2zcUNPDI0uQ-QytK0A1Lw",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 250.87299662593904,
    y: 404.6032513007798,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 73.35633106284752,
    height: 16.596454991594467,
    seed: 697265810,
    groupIds: ["ObK7UHxfv8_xKyhqeF3Kz", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["vpsPPt2cjRVHtA1fPYzkT"],
    fontSize: 6.638581996637786,
    fontFamily: 1,
    text: "(Real Time\nnon-relation database)",
    baseline: 14.596454991594467,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 1448,
    versionNonce: 1171524173,
    isDeleted: false,
    id: "5EyIF6_46wEShia9BUqOj",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 261.825831205109,
    y: 319.24901721330025,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 80.64469390893316,
    height: 24.507555356449387,
    seed: 206699406,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["HEePiCV-0lwHBnxG2scwO"]
  },
  {
    type: "text",
    version: 2059,
    versionNonce: 2060291117,
    isDeleted: false,
    id: "GoM3oT1zkCcuNrRVxus2p",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 271.30326473541754,
    y: 323.8082188393844,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 64.06231626755462,
    height: 11.617518494116124,
    seed: 377998418,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["HEePiCV-0lwHBnxG2scwO"],
    fontSize: 9.294014795292911,
    fontFamily: 1,
    text: "Authentication",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 6157,
    versionNonce: 2111288483,
    isDeleted: false,
    id: "eX5H6B9g8TB9ZENYrznLN",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 364.18408372505667,
    y: 432.1174097281823,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.57219327125177,
    height: 47.20222153134271,
    seed: 1340561870,
    groupIds: ["6qdT2mhTd_v4VgqiO2fGS", "_39oO0nt_qYnYTM7qnsdH", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [-0.2560671205697639, -48.728708699973076],
      [-0.1354708086135504, -13.053525506170619],
      [-0.2504234962745784, -8.992060817658533],
      [1.6274817176677678, -7.237152148469656],
      [8.167192923826267, -5.7519311746073605],
      [19.221157349598137, -5.289455550113948],
      [29.78248937983375, -6.027865629649775],
      [35.39380284888594, -7.793759979718453],
      [36.185202683254495, -9.28242744170006],
      [36.296351925098186, -12.552283044779356],
      [36.20911269458133, -45.73575995394137],
      [36.01244746628013, -48.870987114864825],
      [33.66414370723972, -50.62328619929954],
      [28.71911713926464, -51.63812510717376],
      [17.450069725765054, -52.49167708145666],
      [8.415151735723652, -51.98270211725663],
      [1.30925009593307, -50.2563211413932],
      [-0.2758413461535838, -48.75014462518583],
      [-0.2560671205697639, -48.728708699973076]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 3886,
    versionNonce: 874879757,
    isDeleted: false,
    id: "PP2a1fq8ZbLWIW6pEr_gp",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 364.0451937247161,
    y: 412.8716039172139,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.61012857450799,
    height: 4.061949521860577,
    seed: 137261586,
    groupIds: ["6qdT2mhTd_v4VgqiO2fGS", "_39oO0nt_qYnYTM7qnsdH", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.4174818935439704],
      [0.9645196920383421, -0.7983209304221481],
      [5.124094368784817, 0.5601402377624906],
      [10.659059960298135, 1.3828161070850953],
      [19.330274832985964, 1.457782855193948],
      [29.449285028526216, 0.9340222520124598],
      [35.35890133629643, -0.9714069989928396],
      [36.61012857450799, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 3970,
    versionNonce: 1054812227,
    isDeleted: false,
    id: "cTce1iXUHQq2rJvl5-EHA",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 363.63732921972064,
    y: 399.1834863554409,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.61012857450799,
    height: 4.061949521860577,
    seed: 766963726,
    groupIds: ["6qdT2mhTd_v4VgqiO2fGS", "_39oO0nt_qYnYTM7qnsdH", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.4174818935439704],
      [0.9645196920383421, -0.7983209304221481],
      [5.124094368784817, 0.5601402377624906],
      [10.659059960298135, 1.3828161070850953],
      [19.330274832985964, 1.457782855193948],
      [29.449285028526216, 0.9340222520124598],
      [35.35890133629643, -0.9714069989928396],
      [36.61012857450799, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "ellipse",
    version: 6989,
    versionNonce: 3715437,
    isDeleted: false,
    id: "RL6PCgvcyv_sbm6DmU0Gw",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 363.13684255292117,
    y: 379.97929446215153,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.33761323419469,
    height: 7.349008897526555,
    seed: 1635409874,
    groupIds: ["6qdT2mhTd_v4VgqiO2fGS", "_39oO0nt_qYnYTM7qnsdH", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["bxuMGTzXLn7H-uBCptINx"]
  },
  {
    type: "ellipse",
    version: 2397,
    versionNonce: 1365699853,
    isDeleted: false,
    id: "dubnu6Lb87R8yC4DU5jxY",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 392.78283086660645,
    y: 390.16775331181213,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 5.325625545497352,
    height: 5.77993401039899,
    seed: 1371127374,
    groupIds: ["6qdT2mhTd_v4VgqiO2fGS", "_39oO0nt_qYnYTM7qnsdH", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["5btsb5KANCGip6PmySXqY"]
  },
  {
    type: "ellipse",
    version: 2404,
    versionNonce: 221131651,
    isDeleted: false,
    id: "d_Kez_Kvt-d4042Yu_9E0",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 392.78283086660645,
    y: 402.854697596012,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 5.325625545497352,
    height: 5.77993401039899,
    seed: 243438994,
    groupIds: ["6qdT2mhTd_v4VgqiO2fGS", "_39oO0nt_qYnYTM7qnsdH", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 2486,
    versionNonce: 2019216045,
    isDeleted: false,
    id: "hi9W3cDaS4w1qoocVb1t9",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 392.78283086660645,
    y: 416.64372030942366,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 5.325625545497352,
    height: 5.77993401039899,
    seed: 13157518,
    groupIds: ["6qdT2mhTd_v4VgqiO2fGS", "_39oO0nt_qYnYTM7qnsdH", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["zh7Qs--EdxoFdfj597Pe0"]
  },
  {
    type: "text",
    version: 1715,
    versionNonce: 436022413,
    isDeleted: false,
    id: "eqL_P53H3vHjAuIOmeXlS",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 371.4966522515123,
    y: 402.429041605566,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 18.588029590585805,
    height: 8.298227495797233,
    seed: 1618875218,
    groupIds: ["_39oO0nt_qYnYTM7qnsdH", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637778,
    fontFamily: 1,
    text: "Users",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 6337,
    versionNonce: 1898147523,
    isDeleted: false,
    id: "tXUT0c0JPNz3-UftY6hIn",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 430.02090061383285,
    y: 432.07764645260266,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.57219327125177,
    height: 47.20222153134271,
    seed: 2090664654,
    groupIds: ["_DRjrH5yvRG37-z6HkvLQ", "B13voHCAnRY4rfC8YZqFU", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [-0.2560671205697639, -48.728708699973076],
      [-0.1354708086135504, -13.053525506170619],
      [-0.2504234962745784, -8.992060817658533],
      [1.6274817176677678, -7.237152148469656],
      [8.167192923826267, -5.7519311746073605],
      [19.221157349598137, -5.289455550113948],
      [29.78248937983375, -6.027865629649775],
      [35.39380284888594, -7.793759979718453],
      [36.185202683254495, -9.28242744170006],
      [36.296351925098186, -12.552283044779356],
      [36.20911269458133, -45.73575995394137],
      [36.01244746628013, -48.870987114864825],
      [33.66414370723972, -50.62328619929954],
      [28.71911713926464, -51.63812510717376],
      [17.450069725765054, -52.49167708145666],
      [8.415151735723652, -51.98270211725663],
      [1.30925009593307, -50.2563211413932],
      [-0.2758413461535838, -48.75014462518583],
      [-0.2560671205697639, -48.728708699973076]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 4063,
    versionNonce: 941757165,
    isDeleted: false,
    id: "GLK3ULb14EvvUM6tiCyb0",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 429.88201061349196,
    y: 412.8429730491044,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.61012857450799,
    height: 4.061949521860577,
    seed: 1774442770,
    groupIds: ["_DRjrH5yvRG37-z6HkvLQ", "B13voHCAnRY4rfC8YZqFU", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.4174818935439704],
      [0.9645196920383421, -0.7983209304221481],
      [5.124094368784817, 0.5601402377624906],
      [10.659059960298135, 1.3828161070850953],
      [19.330274832985964, 1.457782855193948],
      [29.449285028526216, 0.9340222520124598],
      [35.35890133629643, -0.9714069989928396],
      [36.61012857450799, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 4147,
    versionNonce: 1626250851,
    isDeleted: false,
    id: "x6IEiWrzpQ3HSPs6iH8Jg",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 429.4741461085023,
    y: 399.1548554873252,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.61012857450799,
    height: 4.061949521860577,
    seed: 1741650190,
    groupIds: ["_DRjrH5yvRG37-z6HkvLQ", "B13voHCAnRY4rfC8YZqFU", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.4174818935439704],
      [0.9645196920383421, -0.7983209304221481],
      [5.124094368784817, 0.5601402377624906],
      [10.659059960298135, 1.3828161070850953],
      [19.330274832985964, 1.457782855193948],
      [29.449285028526216, 0.9340222520124598],
      [35.35890133629643, -0.9714069989928396],
      [36.61012857450799, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "ellipse",
    version: 7166,
    versionNonce: 1637559629,
    isDeleted: false,
    id: "1GhZmXo-iUSc-7QFH-9JW",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 428.97365944169644,
    y: 379.95066359403734,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.33761323419469,
    height: 7.349008897526555,
    seed: 1506469586,
    groupIds: ["_DRjrH5yvRG37-z6HkvLQ", "B13voHCAnRY4rfC8YZqFU", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["bxuMGTzXLn7H-uBCptINx"]
  },
  {
    type: "ellipse",
    version: 2533,
    versionNonce: 2062735875,
    isDeleted: false,
    id: "1a6PWm4fSp6P6uScPXk43",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 458.6196477553814,
    y: 390.1391224437019,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 5.325625545497352,
    height: 5.77993401039899,
    seed: 702097230,
    groupIds: ["_DRjrH5yvRG37-z6HkvLQ", "B13voHCAnRY4rfC8YZqFU", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 2614,
    versionNonce: 96598957,
    isDeleted: false,
    id: "cuCaMdw07FqbVDCAIp6nq",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 458.6196477553814,
    y: 402.82606672790143,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 5.325625545497352,
    height: 5.77993401039899,
    seed: 1495940242,
    groupIds: ["_DRjrH5yvRG37-z6HkvLQ", "B13voHCAnRY4rfC8YZqFU", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["SInoLweRaVOYUG47Zn6r7"]
  },
  {
    type: "ellipse",
    version: 2635,
    versionNonce: 741253539,
    isDeleted: false,
    id: "ZvjD8LqsqVicw1p3vLEdi",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 458.6196477553814,
    y: 416.61508944131083,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 5.325625545497352,
    height: 5.77993401039899,
    seed: 1393757582,
    groupIds: ["_DRjrH5yvRG37-z6HkvLQ", "B13voHCAnRY4rfC8YZqFU", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "text",
    version: 1879,
    versionNonce: 1357827533,
    isDeleted: false,
    id: "-FxXFm0IwxJIhcnRcxNgu",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 437.2457757053322,
    y: 402.58562031984127,
    strokeColor: "#000000",
    backgroundColor: "#1ca9b0",
    width: 18.588029590585805,
    height: 8.298227495797233,
    seed: 1704516178,
    groupIds: ["B13voHCAnRY4rfC8YZqFU", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["SInoLweRaVOYUG47Zn6r7"],
    fontSize: 6.638581996637778,
    fontFamily: 1,
    text: "Posts",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 3276,
    versionNonce: 542286317,
    isDeleted: false,
    id: "r_772qofvxpWIalV4th1Z",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 110.14392221577202,
    y: 389.6511092437197,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 50.857256472862176,
    height: 30.43749462493567,
    seed: 11938766,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["5r80FV_Cc6QA7hBBEbjH9", "vpsPPt2cjRVHtA1fPYzkT"]
  },
  {
    type: "line",
    version: 2997,
    versionNonce: 66559693,
    isDeleted: false,
    id: "7gHEW-G5Pid00Io9VFOVn",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 108.98073964359334,
    y: 393.52539822744325,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 51.23827540711141,
    height: 0,
    seed: 770555922,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [51.23827540711141, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "ellipse",
    version: 2825,
    versionNonce: 267403395,
    isDeleted: false,
    id: "mTKr6ASn7b2Rf3R1yoMma",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 111.92873864387565,
    y: 391.3498409060722,
    strokeColor: "#000000",
    backgroundColor: "#fa5252",
    width: 1.989192859965407,
    height: 1.989192859965407,
    seed: 1088127502,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 2870,
    versionNonce: 1452555565,
    isDeleted: false,
    id: "rT85bkrqP7TYbFBJblrOa",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 116.01004043329098,
    y: 391.3498409060722,
    strokeColor: "#000000",
    backgroundColor: "#fab005",
    width: 1.989192859965407,
    height: 1.989192859965407,
    seed: 1847586258,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 2925,
    versionNonce: 968570915,
    isDeleted: false,
    id: "SrvIdc2_JoH49FEBoUyVx",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 120.25956538224327,
    y: 391.52908514900406,
    strokeColor: "#000000",
    backgroundColor: "#40c057",
    width: 1.989192859965407,
    height: 1.989192859965407,
    seed: 1987842126,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "ellipse",
    version: 3196,
    versionNonce: 1020137357,
    isDeleted: false,
    id: "MRsnrNMy0LbQc7_NG4HFF",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 126.63325871564248,
    y: 397.9128430051292,
    strokeColor: "#000000",
    backgroundColor: "#1ca9b0",
    width: 16.989108003206713,
    height: 16.989108003206713,
    seed: 1262904210,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "draw",
    version: 3832,
    versionNonce: 1250311107,
    isDeleted: false,
    id: "DOR0x5oXpkrdt3dExtUJI",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 143.01073396810284,
    y: 406.0884240855954,
    strokeColor: "#087f5b",
    backgroundColor: "#40c057",
    width: 11.225087090411769,
    height: 9.719824603209304,
    seed: 1030805134,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [-5.587549719767635, -1.7344494791707512],
      [-6.315534266333893, -1.8993442889497845],
      [-8.598906691123393, -4.228569719133945],
      [-10.104313540776426, -3.463430204301542],
      [-10.603037282379253, -0.7906164257074954],
      [-10.06900085754746, 0.945953600291776],
      [-12.516984713388897, 1.7994049797757181],
      [-12.42897464134136, 3.691210705357769],
      [-10.511224305983944, 3.5746114465600547],
      [-9.045476315957314, 2.0346733066989673],
      [-7.027220651409833, 5.371205943064639],
      [-5.752704422869229, 5.49125488407536],
      [-7.089696937122605, 0.1746046574760481],
      [-5.0361285893461964, -0.005468754039961048],
      [-4.329874924766998, 0.5989155696689558],
      [-1.914487391906142, 0.5989155696689558],
      [-1.291897622977128, -1.4819327411827732],
      [-3.908839086267851, -1.292890155913084],
      [-3.4057691682676094, -4.025038468569879],
      [-4.6042273098535365, -3.8601436587908426],
      [-5.682079056411318, -2.101495666628681],
      [-5.587549719767635, -1.7344494791707512]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 3250,
    versionNonce: 887002605,
    isDeleted: false,
    id: "WLrSkvVmzYeZagCQ0PzUc",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 126.25333107457362,
    y: 405.69426544640726,
    strokeColor: "#000000",
    backgroundColor: "#99bcff",
    width: 16.74052148052091,
    height: 0,
    seed: 798499154,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [16.74052148052091, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "line",
    version: 5452,
    versionNonce: 2121255779,
    isDeleted: false,
    id: "-CDQyrDQEQx3lriZCV-u2",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 129.08075698899125,
    y: 402.6111543852205,
    strokeColor: "#000000",
    backgroundColor: "#99bcff",
    width: 11.659518084850141,
    height: 2.271248418652014,
    seed: 1316148430,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -2.4997814452951075],
      [0.30717823811047085, -1.594423868430924],
      [1.631910984407909, -0.8348371799392492],
      [3.3946753866670405, -0.37483608189893897],
      [6.156265978187765, -0.332918248014615],
      [9.378947431916329, -0.625780193335529],
      [11.261029819983936, -1.6912053391059898],
      [11.659518084850141, -2.6041666666666288]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "ellipse",
    version: 3262,
    versionNonce: 969887821,
    isDeleted: false,
    id: "nfEyFGm_JG3RmQQzc0h1a",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 132.3026390113915,
    y: 397.36303416062856,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 6.1753978835337575,
    height: 17.825078448311185,
    seed: 644622098,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["vsWSl8B5nlA9K0hSLAPFk"]
  },
  {
    type: "line",
    version: 5654,
    versionNonce: 163997443,
    isDeleted: false,
    id: "apzv_a4Fg20-h10nTZsMP",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 129.69464656067976,
    y: 416.12076330461815,
    strokeColor: "#000000",
    backgroundColor: "#99bcff",
    width: 11.659518084850141,
    height: 2.344764709480995,
    seed: 1662716686,
    groupIds: ["AGjmyE-cz0KOk8MyAlV3F", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, -3.3880811798443338],
      [1.631910984407909, -5.106916743844901],
      [3.3946753866670405, -5.581807263151281],
      [6.156265978187765, -5.625081903117008],
      [9.378947431916329, -5.322740535039788],
      [11.261029819983936, -4.22282946327827],
      [11.659518084850141, -3.2803171936360127]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "text",
    version: 1856,
    versionNonce: 695844525,
    isDeleted: false,
    id: "9gqC5nprX4ePHGwYBDDeM",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 112.68614582453543,
    y: 425.38482168473354,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 44.14657027764126,
    height: 11.617518494116124,
    seed: 943289554,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.2940147952929,
    fontFamily: 1,
    text: "Front end",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "arrow",
    version: 3196,
    versionNonce: 879718339,
    isDeleted: false,
    id: "vpsPPt2cjRVHtA1fPYzkT",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 239.8818261664114,
    y: 404.8639643437963,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 77.77884177020584,
    height: 0.011784424788783266,
    seed: 434272590,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: {
      elementId: "2zcUNPDI0uQ-QytK0A1Lw",
      focus: 0.9688036528734708,
      gap: 10.991170459527638
    },
    endBinding: {
      elementId: "r_772qofvxpWIalV4th1Z",
      focus: 0.0006511299264119142,
      gap: 1.1018057075713727
    },
    points: [
      [0, 0],
      [-77.77884177020584, 0.011784424788783266]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "rectangle",
    version: 1675,
    versionNonce: 1787257101,
    isDeleted: false,
    id: "cZbi9cZ7YPJqz_MFV0Zd-",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 512.2512636441076,
    y: 292.9965896745189,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 252.68016284832805,
    height: 234.1189296173644,
    seed: 1184303762,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "text",
    version: 1981,
    versionNonce: 1826931267,
    isDeleted: false,
    id: "DHJmxmpnnHD9eNuAO0xxN",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 677.9471016262951,
    y: 411.0122292960821,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 66.38581996637787,
    height: 11.617518494116124,
    seed: 1512185742,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 9.29401479529291,
    fontFamily: 1,
    text: "Cloud Storage",
    baseline: 8.617518494116124,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2075,
    versionNonce: 1383184237,
    isDeleted: false,
    id: "pWT5kQvkbxTXcSXajj7bq",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 680.2251243487174,
    y: 428.14383038334694,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 61.44381045195946,
    height: 9.974644553889517,
    seed: 1748756562,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 7.979715643111618,
    fontFamily: 1,
    text: "(Static assets)",
    baseline: 6.974644553889517,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "rectangle",
    version: 5904,
    versionNonce: 272204259,
    isDeleted: false,
    id: "0LJK8mV_j6YxqQnZE64dd",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 561.7800978754958,
    y: 454.9572632898502,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 23.460277666236003,
    height: 35.59966773856174,
    seed: 940768718,
    groupIds: ["XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["CFu0B4Mw_1wC1Hbgx8Fs0", "XIl_NhaFtRO00pX5Pq6VU", "EndiSTFlx1AT7vcBVjgve", "C-2StpIkQtpu-UJa3MbSe"]
  },
  {
    type: "rectangle",
    version: 5970,
    versionNonce: 1266827725,
    isDeleted: false,
    id: "Lks3DpmB0eu1yOuPLXiLb",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 559.2748852219113,
    y: 452.62709137250454,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 23.460277666236003,
    height: 35.59966773856174,
    seed: 1157565970,
    groupIds: ["4fkSxOKXzIIoVZVQg_ER-", "XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["CFu0B4Mw_1wC1Hbgx8Fs0", "XIl_NhaFtRO00pX5Pq6VU", "EndiSTFlx1AT7vcBVjgve", "C-2StpIkQtpu-UJa3MbSe"]
  },
  {
    type: "rectangle",
    version: 6088,
    versionNonce: 853662797,
    isDeleted: false,
    id: "CyCzFtPdjYjKnRXIfjGdF",
    fillStyle: "solid",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 556.1563816924624,
    y: 449.88737970084355,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 23.460277666236003,
    height: 35.59966773856174,
    seed: 1489900558,
    groupIds: ["XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["CFu0B4Mw_1wC1Hbgx8Fs0", "XIl_NhaFtRO00pX5Pq6VU", "EndiSTFlx1AT7vcBVjgve", "C-2StpIkQtpu-UJa3MbSe"]
  },
  {
    type: "draw",
    version: 5180,
    versionNonce: 1907795235,
    isDeleted: false,
    id: "PVnKE8zqi8deuKTpq-9Wx",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 560.4864203811841,
    y: 467.0377839648561,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 15.461202986431008,
    height: 1.0787542540304353,
    seed: 1909947346,
    groupIds: ["XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -1.464580089033553],
      [13.418065021009433, -1.4123367547415104],
      [15.461202986431008, -2.491091008771946]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5202,
    versionNonce: 642511501,
    isDeleted: false,
    id: "Sj-R-8U42rBX7EEGbjgcA",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 561.0533978072706,
    y: 456.82008473330336,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 15.125151268552445,
    height: 0.9304961432016463,
    seed: 1447846478,
    groupIds: ["XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -1.872801740813073],
      [5.587212805233547, -2.8032978840147194],
      [15.125151268552445, -1.981524355420816]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5230,
    versionNonce: 713820355,
    isDeleted: false,
    id: "1oWlt1q42r_3jcmpUMWRv",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 561.1379165415661,
    y: 476.77236138156445,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 16.04435155569088,
    height: 1.4208747968810027,
    seed: 1289499026,
    groupIds: ["XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -1.3129505375654058],
      [8.766996287009144, -1.3976694580389861],
      [12.487173863077704, -0.5444114283310542],
      [16.04435155569088, -1.9652862252120569]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5265,
    versionNonce: 447224045,
    isDeleted: false,
    id: "6otsFqZbpA3niHTvREHyD",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 561.2163841075599,
    y: 480.3217546149567,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 18.05924988095452,
    height: 0.9657956933989791,
    seed: 593946766,
    groupIds: ["XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -1.5346175114401643],
      [3.3744221150918183, -1.9218600831795716],
      [5.354235773931136, -1.8141899490030338],
      [15.355304335839016, -1.3312921023035436],
      [18.05924988095452, -2.297087795702523]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5232,
    versionNonce: 1446246499,
    isDeleted: false,
    id: "PUbC09RLn3d0q5auwGMw7",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 560.2575602949323,
    y: 460.3003790770549,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 15.57698551107825,
    height: 0.8217735285939012,
    seed: 1497640786,
    groupIds: ["XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -0.3950219149818211],
      [6.0390470477593725, -0.5912874140789839],
      [15.57698551107825, 0.23048611451491735]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "draw",
    version: 5245,
    versionNonce: 1366324045,
    isDeleted: false,
    id: "5kM_pFUG8mRvrlmtXykST",
    fillStyle: "solid",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 560.2813204158538,
    y: 471.97533338685525,
    strokeColor: "#000000",
    backgroundColor: "#fff",
    width: 15.57698551107825,
    height: 0.8217735285939012,
    seed: 1876338382,
    groupIds: ["XrL8K_Zu8LUwv5TZFWmr3", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    points: [
      [0, -0.3950219149818211],
      [2.686613589329246, 0.07896297841743659],
      [6.0390470477593725, -0.5912874140789839],
      [15.57698551107825, 0.23048611451491735]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "text",
    version: 1636,
    versionNonce: 310178819,
    isDeleted: false,
    id: "kwHHa1U0QKDDGkXfTg9JW",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 546.1956047351716,
    y: 498.48961688101053,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 49.78936497478339,
    height: 8.298227495797233,
    seed: 459699474,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.63858199663779,
    fontFamily: 1,
    text: "Suppliers config",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1739,
    versionNonce: 385778093,
    isDeleted: false,
    id: "80xXrSEOvVRx-PyhVI1Dr",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 630.8376887518868,
    y: 358.3013538872209,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 47.46586127596015,
    height: 8.298227495797233,
    seed: 204774670,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["RS83Gyl3NcFtAx_OBFWTb"],
    fontSize: 6.638581996637787,
    fontFamily: 1,
    text: "Suppliers logos",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1959,
    versionNonce: 1063615395,
    isDeleted: false,
    id: "_1i3Ik7gPQZJbaDC_8lg7",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 546.5016868519665,
    y: 357.3660818064714,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 43.81464117780946,
    height: 8.298227495797233,
    seed: 1958347474,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637791,
    fontFamily: 1,
    text: "User avatars",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2048,
    versionNonce: 1887159309,
    isDeleted: false,
    id: "MKloT5aJHDoUhUp3hQAvO",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 548.9122478481727,
    y: 427.3939390380822,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 39.167633780162895,
    height: 8.298227495797233,
    seed: 1308216142,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637767,
    fontFamily: 1,
    text: "Post images",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 1701,
    versionNonce: 958140227,
    isDeleted: false,
    id: "PueKl9gDz1HJa8qtptT-f",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 654.5818941554835,
    y: 366.4892082866616,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 103.90403905322131,
    seed: 2144721042,
    groupIds: ["VkOYYqyVzEdamOs_q_pmh", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [0, 103.90403905322131]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 3097,
    versionNonce: 1024622435,
    isDeleted: false,
    id: "C-2StpIkQtpu-UJa3MbSe",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 654.6105559127643,
    y: 470.2203668993218,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 68.40951596880127,
    height: 0,
    seed: 1937715598,
    groupIds: ["VkOYYqyVzEdamOs_q_pmh", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "CyCzFtPdjYjKnRXIfjGdF",
      focus: 0.14231331302305672,
      gap: 6.584380585264569
    },
    points: [
      [0, 0],
      [-68.40951596880127, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 1713,
    versionNonce: 1375678179,
    isDeleted: false,
    id: "V6hccAGeOGKjvgHz43y0K",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 555.8414198618942,
    y: 470.1974582589902,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 173.98082683248572,
    height: 0,
    seed: 1819342418,
    groupIds: ["pfNIuRUbQU8yaXjJfzpI9", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [-173.98082683248572, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 1866,
    versionNonce: 1240636163,
    isDeleted: false,
    id: "zh7Qs--EdxoFdfj597Pe0",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 381.88693420652044,
    y: 470.4499458117531,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 42.978625380777814,
    seed: 134074318,
    groupIds: ["pfNIuRUbQU8yaXjJfzpI9", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "hi9W3cDaS4w1qoocVb1t9",
      focus: 5.091874866905786,
      gap: 12.989975650712534
    },
    points: [
      [0, 0],
      [0, -42.978625380777814]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "arrow",
    version: 1770,
    versionNonce: 211638915,
    isDeleted: false,
    id: "215dJl3VLvr49PR7kRM0U",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 373.5732284106241,
    y: 331.39680641078513,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 52.092339204541574,
    seed: 1533172754,
    groupIds: ["zXEhigoRZ9xphuC9lotWl", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [0, 52.092339204541574]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 1313,
    versionNonce: 442352429,
    isDeleted: false,
    id: "1v-au1tVNR5n22n1OOd_m",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 373.8727697005345,
    y: 331.5027948915208,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 31.038608970334916,
    height: 0,
    seed: 1200530958,
    groupIds: ["zXEhigoRZ9xphuC9lotWl", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [-31.038608970334916, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 2943,
    versionNonce: 1737376419,
    isDeleted: false,
    id: "5btsb5KANCGip6PmySXqY",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 389.839392658974,
    y: 331.4812876983968,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 52.27636345590207,
    seed: 983632338,
    groupIds: ["R49pOzrrdqIlMNflYmBnF", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "dubnu6Lb87R8yC4DU5jxY",
      focus: -2.1053868442256567,
      gap: 8.029777528145079
    },
    points: [
      [0, 0],
      [0, 52.27636345590207]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 1461,
    versionNonce: 427218317,
    isDeleted: false,
    id: "3M4XluPlhV_JlsbgpvnCJ",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 389.6514493138784,
    y: 331.5027948915208,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 150.46252860388537,
    height: 0,
    seed: 53130318,
    groupIds: ["R49pOzrrdqIlMNflYmBnF", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [150.46252860388537, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 3106,
    versionNonce: 501364195,
    isDeleted: false,
    id: "SInoLweRaVOYUG47Zn6r7",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 540.0629661827322,
    y: 403.6130229530275,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 73.20008266382679,
    height: 0.3227459278414905,
    seed: 558104466,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: {
      elementId: "qdmqDd21H5SDJT1PDxoGh",
      focus: -0.022521692243652334,
      gap: 1
    },
    endBinding: {
      elementId: "-FxXFm0IwxJIhcnRcxNgu",
      focus: -0.8434333916104315,
      gap: 11.029078222987408
    },
    points: [
      [0, 0],
      [-73.20008266382679, -0.3227459278414905]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "line",
    version: 1565,
    versionNonce: 1283365869,
    isDeleted: false,
    id: "hiWkmIqFWbqUzfgTERssy",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 135.36952798533645,
    y: 389.6052915577717,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 0,
    height: 57.93631615004689,
    seed: 78314126,
    groupIds: ["uBeT8PdbuGe8XKTuii31I", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [0, -57.93631615004689]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  },
  {
    type: "arrow",
    version: 2337,
    versionNonce: 344424835,
    isDeleted: false,
    id: "HEePiCV-0lwHBnxG2scwO",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 135.25440095340588,
    y: 331.5794156732834,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 126.20484479478861,
    height: 0,
    seed: 729955666,
    groupIds: ["uBeT8PdbuGe8XKTuii31I", "8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: {
      elementId: "GoM3oT1zkCcuNrRVxus2p",
      focus: -0.3378410953827825,
      gap: 9.84401898722308
    },
    points: [
      [0, 0],
      [126.20484479478861, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: "arrow"
  },
  {
    type: "rectangle",
    version: 2029,
    versionNonce: 729716301,
    isDeleted: false,
    id: "The4q7f57IEdGO_Gzg5nG",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 540.2589547072337,
    y: 309.7614388525333,
    strokeColor: "#c92a2a",
    backgroundColor: "#333300",
    width: 56.202338911379236,
    height: 43.482712077977496,
    seed: 1925740750,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: []
  },
  {
    type: "rectangle",
    version: 1770,
    versionNonce: 1108771075,
    isDeleted: false,
    id: "L0AHZ-9m5lgydvALWurHu",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 626.469449934179,
    y: 310.5395612398492,
    strokeColor: "#c92a2a",
    backgroundColor: "#333300",
    width: 56.202338911379236,
    height: 43.482712077977496,
    seed: 1454555922,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["ZMbBDWRN8s-2erMfJfwPY"]
  },
  {
    type: "rectangle",
    version: 2166,
    versionNonce: 1300218733,
    isDeleted: false,
    id: "qdmqDd21H5SDJT1PDxoGh",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 540.3948952825676,
    y: 381.5045884906321,
    strokeColor: "#c92a2a",
    backgroundColor: "#333300",
    width: 56.202338911379236,
    height: 43.482712077977496,
    seed: 891039502,
    groupIds: ["8vuE9lMLmQD9mrWIDRczU", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: ["SInoLweRaVOYUG47Zn6r7"]
  },
  {
    type: "text",
    version: 1223,
    versionNonce: 1100818189,
    isDeleted: false,
    id: "bkfd5_AfvqdBOSfaOqIIh",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 259.24326360385254,
    y: 265.75274542881,
    strokeColor: "#000000",
    backgroundColor: "#1ca9b0",
    width: 355.8279950197854,
    height: 6.638581996637786,
    seed: 1565298898,
    groupIds: ["D4ZnIC07PdAbt3TSQB-ja", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.31086559731023,
    fontFamily: 1,
    text: "Diagram Of Google Cloud services used by the application (Authentication, Firestore and Cloud Storage) and the relation among them.",
    baseline: 4.638581996637786,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1117,
    versionNonce: 259415107,
    isDeleted: false,
    id: "cTh3tdC5nspiqh6v6_7o_",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 418.65727695115856,
    y: 265.7361410714547,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 36.512200981507796,
    height: 6.638581996637786,
    seed: 1478434126,
    groupIds: ["D4ZnIC07PdAbt3TSQB-ja", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.310865597310225,
    fontFamily: 1,
    text: "Authentication",
    baseline: 4.638581996637786,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1085,
    versionNonce: 249478509,
    isDeleted: false,
    id: "eFaKNAjA-PfTegPbVPRm7",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 459.2773441990929,
    y: 265.7169966707811,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 23.898895187896017,
    height: 6.638581996637786,
    seed: 317105810,
    groupIds: ["D4ZnIC07PdAbt3TSQB-ja", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.310865597310215,
    fontFamily: 1,
    text: "Firestore",
    baseline: 4.638581996637786,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1070,
    versionNonce: 1636293603,
    isDeleted: false,
    id: "-n7av3W40YC_VJAANm7Ji",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 497.423432758844,
    y: 265.7439728717404,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 37.83991738083546,
    height: 6.638581996637786,
    seed: 1898595214,
    groupIds: ["D4ZnIC07PdAbt3TSQB-ja", "yHd6hesAw1Rj8XOVriYu0", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 5.310865597310237,
    fontFamily: 1,
    text: "Cloud Storage",
    baseline: 4.638581996637786,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1598,
    versionNonce: 1079936973,
    isDeleted: false,
    id: "JjFgSzE8ZesQKoLQCuOvC",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 318.17882110052517,
    y: 114.41636653662214,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 237.6612354796331,
    height: 14.936809492435016,
    seed: 1077412946,
    groupIds: ["Wgw6VJRnkUiiBMZ_e6gzv", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 11.949447593948017,
    fontFamily: 1,
    text: "Full-stack app implementation description",
    baseline: 10.936809492435016,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 3283,
    versionNonce: 1619552131,
    isDeleted: false,
    id: "KAz81zbXF7tyNBKTYGJ8V",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 176.67706230632723,
    y: 139.13457292910198,
    strokeColor: "#000000",
    backgroundColor: "transparent",
    width: 520.132899436571,
    height: 49.78936497478339,
    seed: 41329102,
    groupIds: ["zTvxHWvrZlad4v24NoBm0", "Wgw6VJRnkUiiBMZ_e6gzv", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.6385819966378,
    fontFamily: 1,
    text:
      'This is the description of one of the main pieces of code I have ever implemented. It involved not just front end but also back end\nwhich I did for the same time in a professional environment for a production application. The backend technology was implemented using \nGoogle Cloud Platform (GCP) and due to ownership of the code I can\'t do any more than creating this diagram explaining the design of the system :(\n\nThis application was part of a bigger system which contained this as a "social collaboration" section. The best way to describe the app is as a Twitter-like\ntool where users could publish content in a stream of post. These posts could include images, links, tags, labels to other users...',
    baseline: 47.78936497478339,
    textAlign: "center",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 2362,
    versionNonce: 406193709,
    isDeleted: false,
    id: "MIlD1c53EAMtOSrcC_jxV",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "solid",
    roughness: 1,
    opacity: 100,
    angle: 0,
    x: 531.5390690343421,
    y: 139.13557638005244,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 122.81376693779899,
    height: 8.298227495797233,
    seed: 2132257298,
    groupIds: ["zTvxHWvrZlad4v24NoBm0", "Wgw6VJRnkUiiBMZ_e6gzv", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637775,
    fontFamily: 1,
    text: "not just front end but also back end",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1489,
    versionNonce: 850820899,
    isDeleted: false,
    id: "kajQ8142dn0rAdK1a25F4",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 188.58743134960207,
    y: 155.8637028629622,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 74.35211836234322,
    height: 8.298227495797233,
    seed: 1595750414,
    groupIds: ["zTvxHWvrZlad4v24NoBm0", "Wgw6VJRnkUiiBMZ_e6gzv", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637778,
    fontFamily: 1,
    text: "Google Cloud Platform",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1337,
    versionNonce: 1498331277,
    isDeleted: false,
    id: "QjcTXtuBlnNH6C1iycS2R",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 223.49096202743698,
    y: 180.61212384328127,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 194.39564144807608,
    height: 8.06925304124089,
    seed: 377264082,
    groupIds: ["zTvxHWvrZlad4v24NoBm0", "Wgw6VJRnkUiiBMZ_e6gzv", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637784,
    fontFamily: 1,
    text: "tool where users could publish content in a stream of post",
    baseline: 6.06925304124089,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "text",
    version: 1046,
    versionNonce: 847291075,
    isDeleted: false,
    id: "GlJp8k4V7mvBDSxQArfVZ",
    fillStyle: "hachure",
    strokeWidth: 2,
    strokeStyle: "solid",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 659.3151878748629,
    y: 172.3171653404787,
    strokeColor: "#c92a2a",
    backgroundColor: "#1ca9b0",
    width: 37.50798828100346,
    height: 8.298227495797233,
    seed: 253167182,
    groupIds: ["zTvxHWvrZlad4v24NoBm0", "Wgw6VJRnkUiiBMZ_e6gzv", "GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "sharp",
    boundElementIds: [],
    fontSize: 6.638581996637767,
    fontFamily: 1,
    text: "Twitter-like",
    baseline: 6.298227495797233,
    textAlign: "left",
    verticalAlign: "top"
  },
  {
    type: "line",
    version: 1934,
    versionNonce: 761405165,
    isDeleted: false,
    id: "KsJUk01tssW1qpgeitfvn",
    fillStyle: "hachure",
    strokeWidth: 1,
    strokeStyle: "dashed",
    roughness: 0,
    opacity: 100,
    angle: 0,
    x: 15.766232925994156,
    y: 1085.967619102224,
    strokeColor: "#c92a2a",
    backgroundColor: "transparent",
    width: 842.5379908609106,
    height: 0,
    seed: 1451085202,
    groupIds: ["GIykbjzF-JcNMdlm48lKk"],
    strokeSharpness: "round",
    boundElementIds: [],
    startBinding: null,
    endBinding: null,
    points: [
      [0, 0],
      [842.5379908609106, 0]
    ],
    lastCommittedPoint: null,
    startArrowhead: null,
    endArrowhead: null
  }
];

const appState = {
  appearance: "dark"
};

const diagramData = { elements, appState };

export default diagramData;
